const transactionTopics = [
  {
    type: "transaction topic",
    id: "vacantLand",
    title: "Vacant Land (Residential Use)",
    description: `<p>
    Vacant land refers to property that is not currently in use for any specific 
    purpose. Its value and potential depend on various factors, including location, 
    zoning regulations, and land type. The advice provided assumes your client 
    has found a piece of land that appeals to them.
    <br/>
    <br/>
    Proper due diligence is crucial when helping a client purchase vacant land. 
    It ensures the property meets their intended use and protects them from legal, 
    zoning, or environmental issues—allowing for informed, confident decisions.
    <br/>
    <br/>
    This is a general approach to this type of transaction based on a multitude of 
    varying common circumstances. Location can play a large factor in how much due 
    diligence is required since items like road access and connection to services can 
    be much easier to verify in certain situations. Each deal is unique, so the 
    responsibility is on the eXp Realty REALTOR® to perform proper due diligence as 
    part of their legal obligation to provide competent service.
    </p>`,
    text: [
      {
        title: `Common Types Of Land`,
        text: `
    <strong>Raw Land</strong><br/> 
    Land that has never been developed and therefore has no existing structures or 
    utilities like electricity or water.<br/><br/>
    <strong>Vacant Land</strong><br/>
    Like raw land, vacant land is also privately owned. However, unlike raw land, 
    it is serviced or partially serviced. This means that it may have utilities like 
    electricity, water, and septic, and could have pre-existing developments but no 
    permanent structures.<br/><br/> 

    <strong>Crown Land</strong><br/>
    Crown land is public land that is owned by the provincial government of Ontario. 
    The majority of land in the province (87%, to be exact) is Crown land. Most Crown 
    land is in the northern part of the province, whereas 
    the southern part of Ontario is largely privately owned. There are several 
    restrictions and conditions relating to the use of Crown land, whether this use 
    is residential (home) or recreational (cottage). This type of land is typically 
    sold at market value. You will only be able to buy crown land within the bounds 
    of an existing municipality.<br/>
   `,
      },
      {
        title: `What To Consider When Buying Land`,
        text: `
    <strong>Zoning</strong><br/>
    Zoning requirements outline parameters like the types of structures that can be 
    built on it,  maximum building height, lot coverage, and required distance from 
    the sidewalk. They can also sometimes include restrictions on renovations or 
    additions like garages, pools, or decks. Most areas have requirements regarding 
    minimum square footage, the minimum size of a buildable lot, and what kinds of 
    housing can be added to different properties. <br/>
    <strong class="bold">Action:</strong> Confirm Zoning in GeoWarehouse. Contact the 
    local municipality's zoning department to confirm the property's zoning, permitted 
    uses, and any applicable restrictions.<br/><br/>
    <strong>Survey</strong><br/>
    Land surveys are critical for land Buyers. The purpose is to determine the 
    property's legal boundaries and easements. Unless the survey was done within the last 
    year or two, it is essential that you conduct a survey.
    <br/> 
    <strong class="bold">Action:</strong> Confirm if the current owner has a recent 
    land survey. Alternatively, you can connect with the local land registry office 
    to see if they have a copy of the survey or look into having a Licensed Ontario 
    Land Surveyor conduct a survey.<br/>
 
    <br/><strong>Soil test/Percolation test</strong><br/>
     Typically what is needed is a geotechnical 
    investigation. This test helps determine the soil's composition, strength, 
    and stability, which is crucial for designing a safe and structurally sound 
    building foundation. Additionally, a percolation test is essential if 
    the land lacks access to public sewer systems, as it assesses the soil's 
    ability to absorb wastewater for a septic system. Sandy soil, although 
    great for drainage, may require the use of double footings. In many 
    situations, these tests will be a prerequisite for obtaining a building permit.
    <br/> 
    <strong class="bold">Action:</strong> Contact your local municipality to 
    determine whether this test is required for obtaining a building permit. 
    Regardless of the requirement, it is strongly recommended to confirm that the 
    land is suitable for your client's intended use. You may also want to ask the 
    municipality or colleagues if they have a list of approved geotechnical 
    engineers in the area.
    <br/>

    <br/><strong>HST Implications</strong><br/>
     Typically HST does not apply  to the sale of vacant land if it's considered a 
     resale of real property. Depending on the history of the property HST may 
     apply and so it's important to assess each situation to be sure.
    <br/> 
    <strong class="bold">Action:</strong> Have your client reach out to their 
    lawyer or accountant to determine if there are any HST implications with the 
    purchase of the property.
    <br/>

    <br/><strong>Internet/Telecommunications Services</strong><br/>
    Access to high-speed internet and reliable telecommunications is becoming more 
    essential for clients—not just for entertainment, but also due to the growing 
    need for remote work and smart home connectivity.<br/>
    <strong class="bold">Action:</strong> Connect with local service providers to 
    ensure access to high-speed internet and reliable telecommunications are 
    available.
    <br/>
    
    <br/><strong>Finding a Suitable Builder</strong><br/>
    Finding a suitable builder will be paramount to the success of building a 
    property that suits your client's needs. Ensure that you do thorough research 
    on the builder's reputation, experience, and the quality of their work. It is 
    also critical to ensure that the builder is registered with Tarion as Ontario 
    requires new home builders to provide warranty coverage. 
    <br/>
    <strong class="bold">Action:</strong> Search local building associations for 
    a list of builders in the area. Consult with other professionals in the area 
    to get recommendations. Ask for references and check their previous work. 
    Additionally, you can check the builder's website for their portfolio and 
    reviews. Connect your clients with multiple builders so that they can build 
    a relationship with the builder that is most suitable for their needs.
    <br/>

    <br/><strong>Subdivider's Agreement</strong><br/>
    Land in subdivisions often come with a subdivider's agreement, also known as 
    restrictive covenants. Restrictive Covenants are often created by developers 
    and municipalities and can restrict how land can be used. Some examples include: 
    restriction of fences, height of buildings, installation of pools, etc.
    <br/>
    <strong class="bold">Action:</strong> Contact your local municipality to obtain 
    a copy of the subdivider's agreement to assess the terms of the agreement and 
    determine if there are any restrictions on the property. Restrictive Covenants 
    can also be located in the Title Report obtained from GeoWarehouse. Have your 
    client's lawyer review for the presence of Restrictive Covenants.
    <br/>

    <br/><strong>Local Services</strong><br/>
    Schools, Hospitals, Shopping...etc<br/>
    <strong class="bold">Action:</strong> Discuss with your clients to confirm that 
    all essential services are accessible within a reasonable distance, as this 
    will significantly enhance their experience with the property.
    <br/>

    <br/><strong>Power</strong><br/>
    If a parcel does not have water or electricity, it may be necessary to have 
    those services run out to the property. Often, adding these utilities can mean 
    adding tens of thousands of dollars to the cost of building a home.
    If remote, will the law in the area allow for off-grid power sources 
    (ie. solar).<br/>
    <strong class="bold">Action:</strong> Check for existing services by asking the
    Seller/Agent. Verify with the local power provider to verify the information 
    provided. If power is not available, consult with a local power provider to 
    determine the cost of running power to the property.
    <br/>

    <br/><strong>Water well</strong><br/>
    If you're buying vacant land in Ontario that has a well, you will want to 
    conduct a well flow rate test and water quality test. If no well currently 
    exists, you will need to dig a well. Additionally, if there is a shared well,
    between multiple properties, obtaining the agreement would be important.
    <br/>
    <strong class="bold">Action:</strong> If a well needs to be dug, start by 
    consulting a local well contractor to assess the cost, feasibility, and the 
    type of well that can be installed on the property. For testing the water 
    quality of an existing well, you can usually contact your local health 
    department to obtain a water quality test kit. If there is a shared well,
    you will need to obtain the agreement from the other property owners to 
    determine the terms of the shared well agreement.
    <br/>

    <br/><strong>Gas Service</strong><br/>
     Depending on the property's location, it's important to evaluate the different 
     gas service options available, with natural gas and propane being the most 
     common choices. These decisions will influence multiple elements of the home, 
     such as the selection of the furnace, water heater, fireplace, and kitchen 
     appliances.
     <br/>
    <strong class="bold">Action:</strong> Begin by contacting the local utility 
    provider—typically Enbridge Gas in Ontario—to determine if natural gas service 
    is available at or near the property. Provide the property's municipal address 
    and request a service availability check or connection quote. If gas is not readily 
    available, inquire about the cost and feasibility of extending service. It's also 
    advisable to explore alternative options like propane if natural gas is not 
    accessible or cost-effective.
    <br/>
    

    <br/><strong>Septic Systems</strong><br/>
    The property may have to rely on a septic system if it's not connected to 
    municipal sewer lines. Check the land has enough room for an adequate septic 
    system. Appropriate sizing is determined by the size of the house you've planned, 
    the number of bedrooms, number of plumbing fixtures, soil type, and the type of 
    septic system.<br/>
    <strong class="bold">Action:</strong> Verify with the local municipality to 
    determine if a septic system is allowed on the property. If so, consult with 
    a local septic contractor to determine the cost of installing a septic system. 
    The septic system will need to be approved by the local municipality. The size 
    of the septic system will depend on the size of the house you've planned, the 
    number of bedrooms, number of plumbing fixtures, soil type, and the type of 
    septic system.
    <br/>

    

    <br/><strong>Access to Roadway</strong><br/>
    Road access is important for the property's accessibility and value as well 
    as enjoyment of the property. Some rural roads may have limited right of use 
    or are not maintained in the winter. Some properties have private roads with 
    associated rights of use and maintenance agreements.<br/>
    <strong class="bold">Action:</strong> Have the lawyer review the property's 
    title and any associated rights of use and maintenance agreements, if they exist.
    Contact the local municipality to determine if the road is maintained in the 
    winter as well as determining if the road is public or private.    
    <br/>

    <br/><strong>Environmental Protections</strong><br/>
    The local Conservation Authority to make sure your lot is not environmentally 
    protected. It's important to have an assessment done to ensure potential minimum 
    setbacks or no-disturb zones around wetlands, floodplains, or rivers. This way 
    you can have clear direction on where development can and cannot occur on the lot. 
    In some cases, the water table may be too high and it will not be feasible to build
    a home on the property.
    <br/>
    <strong class="bold">Action:</strong> Contact your local Conservation Authority 
    to determine if the property is environmentally protected and if development can 
    occur on the property. Additional permits may be required if the property falls 
    within the boundaries of a protected area.
    <br/>

    <br/><strong>Types of Potential Financing:</strong><br/>
    Land Mortgage: similar to a residential mortgage, except you will need to put 
    down a more significant down payment and pay higher interest rates.<br/>
    Construction Mortgage: type of loan utilized to acquire vacant land so you can 
    build on top.
    <br/>
    Lenders typically offer loans with higher interest rates. Your clients may also be 
    required to make a much larger down payment.<br/>
    <strong class="bold">Action:</strong> Connect your clients with a lender who is 
    experienced in lending for vacant land. Finding an option that is most suitable 
    for their situation will be important.
    `,
      },
      {
        title: `Additional Common Questions`,
        text: `<ol>
    <p>
    <li>Can you build on the land? If so, what are the restrictions? Are there any 
    easements, right-of-ways?</li>
    <li>Are there any minimum lot size requirements for building?</li>
    <li>Is there potential for contaminated soil or past industrial use?</li>
    <li>Is there any Environmental Protection that may be associated with water 
    sources on the property like rivers and flood plains?</li>
    <li>How much work needs to be done on the property before it's ready for 
    development/use. Will trees have to be cleared?</li>
    <li>Does the land have year-round access? What is the proximity to the 
    highway, services and school? What services are nearby?</li>
    <li>How long has the land been on the market? This can be telling as it may indicate 
    that others have done their homework and discovered issues. This can also be an 
    indication of how hard it will be for your client to sell the land down the road.</li>
    <li>Does the property face east, west, north or south? This may seem redundant, 
    but it's important to consider how the property and dream home will interact with 
    the sunrise and sunset.</li>
    <li>How far North is it located? If you're coming from the South, you're likely 
    acclimated to more mild winters. The further North you go, the longer the winter 
    season lasts.</li>
    <li>Soil type - Different types of soil in Ontario can have a huge impact on the 
    usability of land. You'll want to find out if there are any drainage issues or 
    other concerns that may affect your ability to use and develop the property.</li>
    <li>Are there plans for future development in the area which may affect the use & 
    enjoyment of the property? (contact local municipality)</li>
    <li>Are there any Species at Risk or natural heritage features present?</li>
    </ol>
    </p>`,
      },
      {
        title: `Typical Conditions in an Offer`,
        text: `
    <p>No two properties are alike which means that each purchase will be 
    structured differently depending on the situation. If your client wants to "buy 
    now and figure it out later", ensure you complete Form 127. Thoroughly educate 
    your client on the risks of not including a due diligence clause. It will be 
    extremely important for your client to have a lawyer that is experienced in 
    this type of transaction.
    <br/><br/>
    As these transactions can involve multiple conditions and extensive due 
    diligence, consider incorporating a general due diligence clause in your offer. 
    This provides the ability to conduct thorough evaluations and lets your client 
    choose whether to continue with the property purchase.<br/>
    Refer to the client's lawyer and the 
    <a
      href="https://www.orea.com/standard-forms-clauses"
      target="_blank"
      rel="noopener noreferrer"
    >
      BCFSA Clause Section</a> for any additional clauses that may be required.
    <br/><br/>

    <strong>Always Include a Lawyer Review Condition</strong> plus the due
    diligence clause below.<br/><br/>

    <strong>Due Diligence Clause:</strong>
    <br/>
    This Offer is conditional upon the Buyer being able to conduct due diligence for 
    a period of _________ days from the date of acceptance of the Agreement of 
    Purchase and Sale. During this period, the Buyer shall have access to the property 
    for inspections, assessments, and investigations deemed necessary. Unless the 
    Buyer gives notice in writing delivered to the Seller personally or in accordance 
    with any other provisions for the delivery of notice in this Agreement of Purchase 
    and Sale or any Schedule, that this condition is fulfilled, this Offer shall be 
    null and void and the deposit shall be returned to the Buyer in full without 
    deduction. The Seller agrees to co-operate in providing access to the property 
    for the purpose of these investigations. This condition is included for the 
    benefit of the Buyer and may be waived at the Buyer's sole option by notice 
    in writing to the Seller as aforesaid within the time period stated herein.
    <br/>

    <br/>If your client/lawyer wishes to go with individual conditions, consider 
    including the following conditions in the offer. Depending on the  situation, 
    some of these conditions may not be applicable. You may require additional 
    conditions that aren't listed here. </p>
    <br/>
    Conditional Upon:
    <ol>
    <p>
    <li>Lawyer's Review (highly recommended)</li>
    <li>Financing</li>
    <li>Finding out availability of connecting to hydro, water, septic/sewer, 
    internet, etc.</li>
    <li>Obtaining a Building Permit</li>
    <li>Buyer obtaining / Seller providing a Survey</li>
    <li>Verifying Zoning</li>
    <li>Testing well water and Septic systems</li>
    <li>Conducting Environmental Tests</li>
    <li>Performing a Soil Test/Septic Suitability Test</li>
    <li>Satisfactory site assessment/evaluation</li>
    <li>Verifying environmental status with Conservation Authority</li>
    <li>Verifying Legal Road Access</li>
    <li>Completion of Severance</li>
    </ol>
    </p>`,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "singleFamilyBC",
    title: "Single Family Residential (Resale)",
    description: `<p>
    This is typically the most common type of  real estate transaction in most 
    communities. The property may be a single family detached home, duplex, 
    triplex, or fourplex, typically governed by the Real Estate Services Act (RESA) 
    and overseen by the BC Financial Services Authority (BCFSA).
    <br/><br/>
    Evaluating the property requires attention to a wide range of factors, 
    all of which can differ depending on each client's individual goals and priorities. 
    Because your client's priorities may change as they tour properties, having a 
    clear understanding of their initial goals is vital to guiding them effectively 
    through the home-buying process. 
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all 
    situations. REALTORS® are expected to perform proper due diligence and advocate  
    for their clients, in line with professional standards. If it's your first time 
    handling this type of deal, working with a more experienced REALTOR® is strongly 
    recommended—not only to protect your client's best interests and ensure 
    competent service, but also to benefit from the opportunity to learn from their 
    experience.</p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Size, Layout, and Features</strong><br/>
        Ensure the home meets your client's current and future needs in terms of space, layout, and functionality. 
        <br/><strong class="bold">Action:</strong> Help your client define their must-have vs. nice-to-have features. Keep resale value and lifestyle changes in mind.
        <br/><br/>
  
        <strong>Location: Neighbourhood and Amenities</strong><br/>
        Assess proximity to schools, public transit, hospitals, recreation centres, and commercial areas. Municipalities often publish Official Community Plans (OCPs) that outline future neighbourhood changes.
        <br/><strong class="bold">Action:</strong> Review the area's OCP or zoning bylaws to identify any upcoming developments or rezoning that may affect value or livability.
        <br/><br/>
  
        <strong>Property Condition</strong><br/>
        Understand the home’s condition, including structural integrity, roof, plumbing, electrical, foundation, and HVAC systems. Many BC homes—especially on the coast—may also have moisture or drainage concerns.
        <br/><strong class="bold">Action:</strong> Recommend a licensed home inspector registered with Consumer Protection BC. Include a home inspection condition if possible.
        <br/><br/>
  
        <strong>Age of Major Systems</strong><br/>
        Confirm age and service history of major components, including roof, windows, furnace, water heater, and perimeter drains (especially important in coastal BC).
        <br/><strong class="bold">Action:</strong> Request maintenance and service records from the Seller or Listing Agent.
        <br/><br/>
  
        <strong>Zoning and Land Use</strong><br/>
        Check the zoning and permitted uses through the local municipality. In BC, unauthorized suites are common; ensure any secondary units are legal or properly disclosed.
        <br/><strong class="bold">Action:</strong> Verify zoning with the local planning department and confirm whether any suites are authorized.
        <br/><br/>
  
        <strong>Improvements/Renovations and Permits</strong><br/>
        Ask about renovations and confirm whether building permits and final inspections were completed. Unpermitted work can impact financing, insurance, or resale.
        <br/><strong class="bold">Action:</strong> Request a Property Information Report or permit history from the Listing Agent or municipality.
        <br/><br/>
  
        <strong>Utilities and Services</strong><br/>
        Confirm availability of water, sewer, septic, natural gas, and hydro connections. Rural BC properties may have wells or septic systems, which require extra due diligence.
        <br/><strong class="bold">Action:</strong> If applicable, obtain well and septic inspection reports and confirm with the local health authority.
        <br/><br/>
  
        <strong>Title and Ownership</strong><br/>
        Verify title for charges, easements, covenants, or rights-of-way. BC titles are available through the Land Title and Survey Authority (LTSA).
        <br/><strong class="bold">Action:</strong> Obtain a title search through LTSA and have the Buyer’s lawyer review it.
        <br/><br/>
  
        <strong>Environmental and Natural Hazards</strong><br/>
        BC properties may be subject to floodplains, wildfire zones, or oil storage tanks.
        <br/><strong class="bold">Action:</strong> Review the property’s floodplain map, wildfire risk zone, and oil tank records if applicable. Recommend additional inspections if risk factors exist.
        <br/><br/>
  
        <strong>Insurance and Risk Factors</strong><br/>
        Homes in flood or forest interface areas may have higher insurance costs.
        <br/><strong class="bold">Action:</strong> Encourage your client to obtain an insurance quote before removing conditions. Confirm that electrical and plumbing systems meet insurer standards.
        <br/><br/>
  
        <strong>Disclosures</strong><br/>
        In BC, Sellers must complete a Property Disclosure Statement (PDS) unless exempt (e.g., foreclosures, estates). Ensure all known material latent defects are disclosed.
        <br/><strong class="bold">Action:</strong> Review the PDS carefully and discuss any red flags with your client.
        <br/><br/>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Pre-Approval</strong><br/>
        A mortgage pre-approval provides a clear budget and strengthens your client’s offer.
        <br/><strong class="bold">Action:</strong> Connect your client with a licensed mortgage broker or lender early in the process.
        <br/><br/>
  
        <strong>Appraisal Requirements</strong><br/>
        Lenders may require an appraisal to confirm market value. The appraiser must be licensed through the Appraisal Institute of Canada (AIC) or the Real Estate Institute of BC (REIBC).
        <br/><strong class="bold">Action:</strong> Coordinate with the lender to ensure a timely appraisal once conditions are accepted.
        <br/><br/>
  
        <strong>Deposit Amount</strong><br/>
        Deposits in BC are typically between 5% and 10% of the purchase price and held in the 
        Buyer Brokerage's trust account.
        <br/><strong class="bold">Action:</strong> Ensure the deposit is delivered on time and documented in accordance with brokerage trust account rules.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What is the property’s ownership and maintenance history?</li>
        <li>Were recent renovations permitted and inspected?</li>
        <li>Are there any registered easements, covenants, or rights-of-way?</li>
        <li>Are property taxes and utilities current?</li>
        <li>Has the property ever been affected by floods, oil tanks, or landslides?</li>
        <li>What are local zoning or OCP changes that could impact the property?</li>
        <li>What are the average annual costs for insurance, utilities, and maintenance?</li>
        <li>Is the home still covered under a New Home Warranty (if built within the last 10 years)?</li>
        <li>Are there any restrictions under the Home Buyer Rescission Period (HBRP) rules?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        In BC, Buyers also have the right to rescind a contract within 3 business days under the Home Buyer Rescission Period (HBRP).
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "condoResaleBC",
    title: "Residential Condo (Resale)",
    description: `<p>
    Condominium resale transactions in British Columbia involve purchasing a previously owned strata-titled property—such as an apartment, townhouse, or other multi-unit dwelling—governed under the Strata Property Act and overseen by the BC Financial Services Authority (BCFSA).
    <br/><br/>
    Unlike detached homes, condo ownership typically includes individual ownership of the strata lot (the unit) and shared ownership of common property (hallways, amenities, roofs, etc.). 
    <br/><br/>
    Evaluating a condo requires careful review of both the physical condition of the unit and the financial and governance health of the strata corporation. Strata documentation and meeting minutes often reveal key information about upcoming expenses, bylaw changes, or ongoing disputes.
    <br/><br/>
    Every condo and strata corporation operates differently, and REALTORS® must perform thorough due diligence to protect their client’s interests. 
    <br/><br/>
    If it’s your first time handling a strata transaction, partnering with an experienced REALTOR® or seeking guidance from your managing broker is highly recommended—to ensure your client receives competent service and that you understand the complexities unique to strata resale transactions.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those 
        considerations will apply to condos as well. For condos specifically, here 
        are some additional items to consider.
        <br/><br/>
        <strong>Strata Documents and Financial Health</strong><br/>
        Strata documents provide insight into the corporation’s governance, finances, and maintenance planning.
        <br/><strong class="bold">Action:</strong> Obtain and review the full strata document package: Form B Information Certificate, Form F Payment Certificate, bylaws, rules, depreciation report, AGM and council minutes (at least 2 years), insurance certificate, financial statements, and budget. Pay special attention to upcoming special levies, contingency reserve fund (CRF) balance, and any ongoing legal actions.
        <br/><br/>
  
        <strong>Strata Fees and Special Levies</strong><br/>
        Monthly strata fees cover shared expenses such as building maintenance, management, insurance, and utilities (where applicable).
        <br/><strong class="bold">Action:</strong> Confirm current strata fees, assess recent increases, and determine if there are any approved or pending special assessments.
        <br/><br/>
  
        <strong>Building Condition and Maintenance</strong><br/>
        Evaluate the age and maintenance of key building systems—roof, plumbing, windows, elevators, and envelope. In coastal or high-rainfall areas of BC, building envelope condition is critical.
        <br/><strong class="bold">Action:</strong> Review the depreciation report and engineering assessments. Identify any recent or upcoming major projects.
        <br/><br/>
  
        <strong>Unit Condition</strong><br/>
        Inspect the unit for wear, water leaks, ventilation issues, or noise transmission. Note any unapproved alterations or renovations.
        <br/><strong class="bold">Action:</strong> Recommend a qualified home inspector familiar with multi-unit construction. Confirm that any renovations within the unit complied with strata bylaws and city permits.
        <br/><br/>
  
        <strong>Bylaws, Rules, and Restrictions</strong><br/>
        Strata corporations can restrict pets, rentals, smoking, short-term rentals, age (in limited cases), and use of amenities.
        <br/><strong class="bold">Action:</strong> Review bylaws with your client to confirm compatibility with their intended use (e.g., pet ownership, rental intentions, EV charging, renovations).
        <br/><br/>
  
        <strong>Parking and Storage</strong><br/>
        Parking and storage may be common property, limited common property, or strata lot owned. Rights can differ significantly.
        <br/><strong class="bold">Action:</strong> Verify on the Form B whether parking and storage are allocated to the strata lot, limited common property, or assigned by the strata corporation.
        <br/><br/>
  
        <strong>Strata Insurance and Deductibles</strong><br/>
        The strata corporation insures the building, but owners must carry unit-owner insurance to cover personal contents, betterments, and strata deductibles (which can be substantial).
        <br/><strong class="bold">Action:</strong> Review the strata insurance summary, especially water-damage and earthquake deductibles. Advise clients to confirm adequate coverage through their insurer.
        <br/><br/>
  
        <strong>Title and Charges</strong><br/>
        Review the title for financial charges, easements, or covenants. Verify the strata plan to confirm unit boundaries and common property.
        <br/><strong class="bold">Action:</strong> Obtain a title search and strata plan through LTSA. Have legal counsel review if any complexities exist.
        <br/><br/>
  
        <strong>Noise, Bylaw Enforcement, and Strata Culture</strong><br/>
        Review minutes for complaints, disputes, or recurring issues with noise, rentals, or neighbours.
        <br/><strong class="bold">Action:</strong> Discuss with your client whether the strata’s culture and management style align with their lifestyle.
        <br/><br/>
  
        <strong>Disclosures</strong><br/>
        Sellers must complete a Property Disclosure Statement – Strata Version (PDS), unless exempt. Ensure accurate disclosure of any known building issues or special assessments.
        <br/><strong class="bold">Action:</strong> Review the PDS and strata documentation for consistency.
        <br/><br/>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Pre-Approval</strong><br/>
        Pre-approval clarifies budget and strengthens the Buyer’s offer. Lenders may have stricter requirements for older or self-managed strata corporations.
        <br/><strong class="bold">Action:</strong> Encourage early pre-approval and confirm the lender accepts the building (especially for smaller, self-managed, or leasehold stratas).
        <br/><br/>
  
        <strong>Appraisal Requirements</strong><br/>
        Lenders often require an appraisal to confirm market value and review the strata’s financial health.
        <br/><strong class="bold">Action:</strong> Coordinate the appraisal and provide strata documents promptly if requested by the lender or appraiser.
        <br/><br/>
  
        <strong>Deposit Amount</strong><br/>
        Deposits in BC are typically 5–10% of the purchase price and held in the 
        Buyer Brokerage's trust account.
        <br/><strong class="bold">Action:</strong> Ensure timely deposit delivery and compliance with brokerage trust rules.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What is the current strata fee, and what does it cover?</li>
        <li>Are there any special levies—approved or pending?</li>
        <li>What is the status of the building envelope and roof?</li>
        <li>How much is in the Contingency Reserve Fund (CRF)?</li>
        <li>Are there any bylaw restrictions (pets, rentals, age, smoking, short-term rentals)?</li>
        <li>How are parking and storage allocated?</li>
        <li>Is the strata corporation involved in any legal disputes?</li>
        <li>What is the insurance deductible amount for water damage?</li>
        <li>Has there been any history of building envelope repairs or insurance claims?</li>
        <li>What is the remaining lifespan of key systems (roof, plumbing, elevators)?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        In BC, Buyers also have the right to rescind a contract within 3 business days under the Home Buyer Rescission Period (HBRP).
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        `,
      },
    ],
  },

  {
    type: "transaction topic",
    id: "preconcondo",
    title: "Pre-Construction Condo",
    description: `<p>
    Purchasing a pre-construction condo involves buying a unit that has not yet 
    been built or is currently under construction, typically directly from the 
    developer or through the REALTOR® representing them. These transactions 
    differ significantly from resale purchases, with longer timelines, more 
    complex contracts, and distinct rights and obligations under the Real Estate 
    Development Marketing Act (REDMA) and the Strata Property Act.
    <br/><br/>
    REALTORS® play a vital role in helping clients navigate the Contract of 
    Purchase and Sale, understand developer disclosure statements, construction 
    schedules, completion costs, and the 7-day rescission period provided under 
    REDMA. A careful review of all documentation, deposit structures, and 
    expectations is essential to protect the Buyer's interests and ensure an 
    informed and confident purchasing experience.
    <br/><br/>
   Every transaction/property is unique, and the guidance provided may not address all
   situations. REALTORS® are expected to perform proper due diligence and advocate for
   their clients, in line with professional standards. If it's your first time
   handling this type of deal, working with a more experienced REALTOR® is strongly
   recommended—not only to protect your client's best interests and ensure
   competent service, but also to benefit from the opportunity to learn from their
   experience.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        The <a href="https://www.bcfsa.ca/" rel="noopener noreferrer" 
        target="_blank">BC Financial Services Authority (BCFSA)</a> provide 
        valuable resources on pre-sale condo purchases, strata ownership, and 
        Buyer protections. Encourage your client to review these before entering 
        into a purchase agreement.
        <br/><br/>
        <strong>7-Day Rescission Period</strong><br/>
        Under BC's Real Estate Development Marketing Act (REDMA), Buyers have a 
        7-day rescission (cooling-off) period after receiving the developer's 
        disclosure statement.
        <br/><strong class="bold">Action:</strong> Advise clients to consult a real estate lawyer 
        during this period to review the Disclosure Statement, Purchase Agreement, and any marketing 
        materials. Ensure you are familiar with rescission timelines in case the client wishes to 
        exercise their right to withdraw.
        <br/><br/>
      
        <strong>Builder & Developer Reputation</strong><br/>
        Research the developer's track record, financial stability, and quality of past projects. 
        Builders must be licensed through <a href="https://www.bchousing.org/licensing-consumer-services" target="_blank">BC Housing’s Licensing and Consumer Services</a>.
        <br/><strong class="bold">Action:</strong> Verify that the developer and builder are 
        properly licensed with BC Housing and that the project is enrolled in the mandatory 
        home warranty insurance program. Review prior developments, online feedback, and speak 
        with REALTORS® familiar with the developer's reputation.
        <br/><br/>
      
        <strong>Disclosure Statement (REDMA Requirement)</strong><br/>
        The Disclosure Statement outlines key information about the development, strata plans, 
        proposed bylaws, construction timelines, and material facts that could impact the purchase.
        The 7-day rescission period begins only once this document has been provided. 
        <br/><strong class="bold">Action:</strong> Ensure your client receives and reviews the 
        Disclosure Statement before signing. Encourage clients to have their lawyer explain any clauses 
        related to deposit structures, changes, or rights to amend.
        <br/><br/>
      
        <strong>Parking & Storage</strong><br/>
        Parking and storage lockers can be critical to convenience and resale value. 
        Strata developments, these may be designated as common property, limited common 
        property, or separately titled.
        <br/><strong class="bold">Action:</strong> Confirm how parking and lockers are allocated, 
        whether they are included in the purchase price, and how ownership or usage rights are 
        defined in the strata plan and disclosure statement.
        <br/><br/>
      
        <strong>Accessibility</strong><br/>
        Ensure the building design supports clients with accessibility needs (e.g., wide doorways, 
        ramps, elevators, and accessible parking).
        <br/><strong class="bold">Action:</strong> Verify accessibility features in the developer’s 
        plans and confirm any available customizations or strata accommodation procedures.
        <br/><br/>
      
        <strong>Construction Delays & Timelines</strong><br/>
        Pre-sale projects can experience delays due to permitting, financing, or construction factors. 
        Completion may occur several years after purchase.
        <br/><strong class="bold">Action:</strong> Set realistic expectations for completion and 
        closing dates. Review the developer’s rights under the purchase contract to extend timelines, 
        and ensure clients understand both early and late completion risks.
        <br/><br/>
      
        <strong>Completion</strong><br/>
        Ownership transfers upon completion and registration of the strata plan. 
        Buyers may still face occupancy delays if construction or municipal 
        approvals are not finalized.
        <br/><strong class="bold">Action:</strong> Explain to clients how 
        completion and possession dates work and confirm with the lawyer what 
        payments and adjustments will be due at completion.
        <br/><br/>

        <strong>Closing Costs & Adjustments</strong><br/>
        Buyers should budget for additional costs beyond the purchase price — such as GST, 
        Property Transfer Tax (PTT), legal fees, strata fees, and utility connections.
        <br/><strong class="bold">Action:</strong> Review all estimated adjustments in the 
        Statement of Adjustments and ensure clients understand potential GST rebates for 
        primary residences. Discuss possible caps on developer-imposed fees where applicable.
        <br/><br/>
      
        <strong>Home Warranty Coverage</strong><br/>
        All new homes in BC must include 2-5-10 home warranty insurance coverage through a 
        provider approved by BC Housing (2 years on labour and materials, 5 years on building 
        envelope, 10 years on structure).
        <br/><strong class="bold">Action:</strong> Confirm the project’s enrolment and 
        warranty provider. Direct clients to 
        <a href="https://www.bchousing.org/licensing-consumer-services/public-registry" target="_blank">
        BC Housing’s Public Registry</a> to verify details.
        <br/><br/>
      
        <strong>GST & New Housing Rebate</strong><br/>
        GST applies to new construction homes in BC. Buyers may qualify for the 
        federal GST New Housing Rebate depending on purchase price and intended use.
        <br/><strong class="bold">Action:</strong> Confirm whether GST is included in the advertised 
        price and who will apply for the rebate (Buyer or Developer). Ensure clients consult 
        their lawyer or accountant for rebate eligibility.
        <br/><br/>
      
        <strong>Assignment Rights</strong><br/>
        Assignment rights allow a Buyer to sell their contract before completion. Developers may 
        restrict or charge fees for assignment.
        <br/><strong class="bold">Action:</strong> Review the Purchase Contract to confirm whether 
        assignments are permitted, and under what terms. Explain potential tax implications and 
        BCFSA disclosure requirements related to assignments.
        <br/><br/>
      
        <strong>Strata Considerations</strong><br/>
        Buyers in BC are purchasing both a unit and shared ownership in common property under the 
        <em>Strata Property Act</em>.
        <br/><strong class="bold">Action:</strong> Ensure clients understand strata bylaws, 
        management structure, pet and rental restrictions, and monthly maintenance fees as 
        disclosed in the developer’s documents.
        <br/><br/>
        `,
      },
      {
        title: "Financing & Deposits",
        text: `
        <strong>Deposit Structure</strong><br/>
        Deposits are typically paid in stages (e.g., 5% at signing, 5% in 90 days, 
        etc.).
        <br/><strong class="bold">Action:</strong> Review the deposit schedule in the 
        builder agreement and confirm funds availability with the Buyer.
        <br/><br/>
  
        <strong>Mortgage Pre-Approval Limitations</strong><br/>
        Since final closing may be years away, most lenders won't lock in rates far 
        in advance.
        <br/><strong class="bold">Action:</strong> Have the client speak to a mortgage 
        professional about pre-qualification and potential changes in borrowing power.
        <br/><br/>
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>What is the developer’s reputation, licensing status, and track record with past projects?</li>
          <li>Are assignment rights permitted, and what are the associated conditions or fees?</li>
          <li>What are the estimated completion and possession dates?</li>
          <li>Are development levies, strata fees, or other builder-related charges capped or subject to change?</li>
          <li>What are the estimated monthly strata maintenance fees and what do they include?</li>
          <li>Is parking or storage included in the purchase price, or are they sold separately?</li>
          <li>Is GST included in the purchase price, and who will claim the GST New Housing Rebate?</li>
          <li>What deposit structure is required, and how is the deposit protected (e.g., held in trust or insured)?</li>
          <li>What home warranty coverage is provided under BC Housing’s mandatory 2-5-10 Home Warranty Insurance program?</li>
          <li>What rights does the Buyer have under the 7-day rescission period as set out by the Real Estate Development Marketing Act (REDMA)?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "assignment",
    title: "Assignments (Pre-Construction)",
    description: `<p>
    An Assignment involves a Seller (Assignor) transferring their 
    rights and obligations under a Contract of Purchase and Sale to another Buyer 
    (Assignee) before the original transaction is completed. This is most common in 
    pre-construction condo transactions but can also apply to freehold properties if 
    permitted. Essentially, the Buyer (Assignee) is buying the Seller's (Assignor) contract and assuming 
    it from when the assignment is finalized. Typically the completion of the 
    assignment occurs once the Builder advises the building/unit is finished and 
    the strata plan is registered (if applicable).
    <br/><br/>
    REALTORS® must ensure that both parties understand the legal and financial 
    implications of assignments, which often include Builder/Developer consent, 
    additional fees, and unique closing considerations. Legal review and proper 
    disclosures are essential to protect all parties.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address 
    all situations. REALTORS® are expected to perform proper due diligence and 
    advocate for their clients, in line with professional standards. If it's your 
    first time handling this type of deal, working with a more experienced REALTOR® 
    is strongly recommended—not only to protect your client's best interests and 
    ensure competent service, but also to benefit from the opportunity to learn from 
    their experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) and Pre-Construction Condo
        sections, as many of those considerations will apply to this scenario as well. 
        Here are some extra things to consider specifically when it comes to 
        assignments.
        <br/><br/>

       <strong>Original Contract of Purchase and Sale</strong><br/>
        Reviewing the original Purchase Contract is essential, as it forms the basis 
        for what is being assigned. It outlines all terms, obligations, timelines, 
        deposits, and any restrictions on assignment.
        <br/><strong class="bold">Action:</strong> Obtain and review the Original 
        Purchase Contract to confirm the details of what is being assigned. Most of 
        the due diligences listed below will apply to the original Purchase Contract.
        <br/><br/>

        <strong>Builder Consent</strong><br/>
        Most pre-construction assignments require written consent from the Builder, 
        often subject to a fee and legal review.
        <br/><strong class="bold">Action:</strong> Confirm whether the original 
        Builder's Agreement permits assignments and under what conditions.
        <br/><br/>
  
        <strong>Assignment Fees and Conditions</strong><br/>
        Builders typically charge administrative, legal, and consent fees. Some limit 
        when the assignment can occur (Example: only after 80% of units are sold).
        <br/><strong class="bold">Action:</strong> Review the Builder's Agreement and 
        disclosure statement for all fees, restrictions, and timing windows. Determine 
        who (Assignor or Assignee) is responsible for these fees in the Assignment 
        Agreement.
        <br/><br/>
  
        <strong>Profit (Lift) & Tax Implications</strong><br/>
        Assignment profit (“lift”) is typically taxable. GST may apply to the assignment 
        amount, and profit is generally treated as business income unless circumstances 
        support capital-gain treatment. PTT implications may also arise.
        <br/><strong class="bold">Action:</strong> Advise both parties to obtain 
        professional tax advice regarding GST, income tax, and Property Transfer Tax 
        (PTT). Document that tax advice was recommended.
        <br/><br/>

        <strong>Profit Payment Timing</strong><br/>
        Assignors often seek profit upfront, but this poses significant risks if the 
        project fails to close or is canceled by the builder.
        <br/><strong class="bold">Action:</strong> Structure the Assignment Agreement 
        so that any profit is paid on final closing, not at the time of assignment.
        <br/><br/>

        <strong>Buying/Selling at a Loss</strong><br/>
        While uncommon, some Builders restrict assignments that involve a sale below 
        the original purchase price, as this can negatively impact future property 
        valuations. When an assignment is sold at a loss, it's crucial to ensure 
        the financial shortfall is properly addressed within the agreement.
        <br/><strong class="bold">Action:</strong> If the assignment is being sold 
        at a loss, speak to your Managing Broker immediately. Confirm that sufficient 
        funds are available—often covered by the forfeiture of the Assignor's 
        deposits—and clearly outline this within the Assignment Agreement.
        <br/><br/>
  
        <strong>Transparency & Disclosure</strong><br/>
        Assignees must be fully informed about the original agreement's terms and any 
        changes made prior to assignment. Under BC's Real Estate Services Act (RESA), 
        proper disclosure is essential.
        <br/><strong class="bold">Action:</strong>  
        Request all amendments, notices of material change, incentive agreements, and 
        builder correspondence. Attach all supporting documents to the Assignment 
        Agreement and obtain written acknowledgment from the Assignee.
        <br/><br/>
  
        <strong>Legal Review of All Agreements</strong><br/>
        Assignment transactions involve multiple layers of legal review: the Original 
        Contract of Purchase and Sale, the Builder's consent, and the new Assignment 
        Agreement.
        <br/><strong class="bold">Action:</strong> Ensure clients retain an experienced 
        BC Real Estate Lawyer early in the process to review all documents.
        <br/><br/>

        <strong>Closing Cost Surprises</strong><br/>
        Uncapped adjustments—such as development levies or meter installations—can 
        amount to tens of thousands of dollars, often catching Assignees by surprise.
        <br/><strong class="bold">Action:</strong> Check the original Builder's 
        Agreement to see if caps were negotiated on closing adjustments or ensure 
        Assignors assume excess costs beyond a set threshold.
        <br/><br/>

        <strong>CSAIR (Condo & Strata Assignment Integrity Register) Requirements</strong><br/>
        Developers must collect and report assignment information to CSAIR for 
        assignments signed on or after January 1, 2019.
        <br/><strong class="bold">Action:</strong> Ensure both Assignor and Assignee 
        are aware that the developer will collect required personal and transactional 
        details for CSAIR reporting.
        <br/><br/>

        <strong>Transfer of Builder Documents & Benefits</strong><br/>
        Builder rebates, warranty rights, parking/locker allocations, and deficiency 
        documentation must transfer to the Assignee for them to receive full benefits.
        <br/><strong class="bold">Action:</strong> Include clauses requiring the 
        Assignor to provide all builder documents, warranty information, rebate 
        entitlements, and deficiency reports to the Assignee upon completion.
        <br/><br/>

        <strong>Rebate and Document Transfer</strong><br/>
        Assignors may receive builder rebates, warranties, and deficiency lists 
        which Assignees (Buyer) must access for full entitlement.
        <br/><strong class="bold">Action:</strong> Include clauses in the agreement 
        obligating Assignors to transfer all relevant Builder documents and 
        benefits to the Assignee.
        <br/><br/>
        
        `,
      },
      {
        title: "Financing & Payment Structure",
        text: `
        <strong>Deposit Transfers</strong><br/>
        The Assignee (Buyer) typically reimburses the Assignor (Seller) for all deposits 
        paid to date and may also pay an additional assignment premium ("lift"). 
        Developers often require the Assignor to sign a deposit transfer form as part of 
        the assignment approval.
        <br/><strong class="bold">Action:</strong> Clarify total deposit amounts, the 
        payment schedule, and any deposit installments still owing to the Builder. 
        Confirm whether the developer has specific procedures or forms for transferring 
        deposits, as requirements vary between projects.
        <br/><br/>
  
        <strong>Financing for Assignment Purchases</strong><br/>
        Some lenders are hesitant to finance assignment transactions due to timing, 
        legal complexity, or valuation risks.
        <br/><strong class="bold">Action:</strong> Refer the Assignee to mortgage 
        professionals with experience in Assignment financing.
        <br/><br/>
  
        <strong>Final Closing Obligations</strong><br/>
        The Assignee assumes all closing costs, levies, and obligations from the 
        original Purchase Contract at final closing.
        <br/><strong class="bold">Action:</strong> Ensure Assignees understand all 
        projected closing costs, including capped or uncapped development charges.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>Is the original Contract of Purchase and Sale assignable, and has the 
          Builder approved it? (Includes any required Developer Consent forms.)</li>
          <li>What is the total profit or premium being paid to the Assignor, and when 
          is it payable?</li>
          <li>Is the assignment being sold at a loss? If so, has it been confirmed that 
          the Builder allows below-market assignments, and who is responsible for 
          covering the loss?</li>
          <li>Are there any Assignment fees, restrictions, blackout periods, or 
          Developer-imposed conditions specific to this project?</li>
          <li>How will deposits be transferred or reimbursed? Does the Builder require 
          a specific Developer Deposit Transfer Authorization form?</li>
          <li>What are the GST implications for the Assignment profit, and has the 
          Assignor been advised to obtain tax advice?</li>
          <li>Are there any material changes to the unit or closing terms disclosed by 
          the Builder (via amendments or Disclosure Statement updates)?</li>
          <li>Has the Assignee secured financing, and does the lender accept assignment 
          purchases for this development?</li>
          <li>What documents must be provided to the Builder and the lawyer or 
          notary? (e.g., Contract of Purchase and Sale, amendments, ID verification, Assignment Agreement, Developer Consent forms.)</li>
          <li>Does the Assignee understand all builder closing adjustments and 
          levies, including any capped or uncapped development charges shown in the 
          Purchase Contract?</li>
        </ol>
        `,
      },

      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>"Time is of the essence" applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like "five business days").</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        <br/><br/>

        <strong>Typically all pre-construction assignments should have the following at minimum:
        </strong><br/><br/>
        <strong>Builder Consent Condition</strong><br/>
        This condition ensures the developer/builder formally approves the assignment 
        before it becomes binding.
        <br/><br/>
  
        <strong>Assignor & Assignee Lawyer Review Condition</strong><br/>
        Both parties should have the right to legal review of the assignment agreement 
        and original Purchase Contract.
        <br/><br/>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "FSBO",
    title: "For Sale by Owner (Residential Resale)",
    description: `<p>
    Purchasing a property directly from a private Seller — also known as a For Sale By 
    Owner (FSBO) transaction — involves buying without the Seller being represented by 
    a REALTOR®. While FSBO sales may appear simpler or more 
    cost-effective, they can present added risks, legal gaps, and communication 
    challenges for the Buyer and their REALTOR®.
    <br/><br/>
    REALTORS® working with Buyers must ensure rigorous due diligence, 
    careful negotiation, and clear communication. It's crucial to protect the Buyer's 
    interests through thorough documentation & lawyer involvement.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address 
    all situations. REALTORS® are expected to perform proper due diligence and 
    advocate for their clients, in line with professional standards. If it's your 
    first time handling this type of deal, working with a more experienced REALTOR® 
    is strongly recommended—not only to protect your client's best interests and 
    ensure competent service, but also to benefit from the opportunity to learn from 
    their experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) or Residential Condo (Resale) 
        section, as many of those considerations will apply to this scenario as well. 
        For For Sale By Owner (FSBO) properties, here are some 
        additional items to consider.
        
        <br/><br/>
      
        <strong>Unrepresented Seller Risk</strong><br/>
        FSBO Sellers may not be familiar with BC's standard real estate processes, 
        contracts, or disclosure obligations under the <em>Real Estate Services Act (RESA)</em>.
        <br/><strong class="bold">Action:</strong> Clearly explain the REALTOR®'s role 
        to both Buyer and Seller. Provide the BCFSA “Disclosure of Representation 
        in Trading Services” form early in the process to ensure the Seller 
        understands the implications of being unrepresented and their 
        responsibilities when selling privately.
        <br/><br/>
      
        <strong>Seller Identification and Authority to Sell</strong><br/>
        FSBO Sellers may not have confirmed ownership authority, especially in cases 
        involving estates, divorces, corporations, or powers of attorney.
        <br/><strong class="bold">Action:</strong> Request valid identification and 
        verify ownership through the Land Title and Survey Authority of British Columbia (LTSA). 
        In estate or power of attorney cases, obtain and review supporting documentation 
        with the Buyer's lawyer to ensure the Seller has legal authority to convey title. 
        <br/><br/>
      
        <strong>Property Disclosure and Inspection</strong><br/>
        Unrepresented Sellers may be unaware of the requirement to disclose known material 
        latent defects or other issues that could affect the property’s value or safety.
        <br/><strong class="bold">Action:</strong> Request a completed 
        Property Disclosure Statement (PDS) where possible, and encourage a 
        professional home inspection. Ask detailed questions about renovations, systems, 
        and the property’s history to ensure full transparency.
        <br/><br/>
      
        <strong>Accurate Market Value & Negotiation</strong><br/>
        FSBO Sellers may lack access to market data and could misprice their property. 
        Emotional attachment may also impact negotiations.
        <br/><strong class="bold">Action:</strong> Prepare a thorough Comparative Market 
        Analysis (CMA) to support your client’s offer strategy. Keep communications clear, 
        professional, and in writing to prevent misunderstandings.
        <br/><br/>
      
        <strong>Clarity on Inclusions and Exclusions</strong><br/>
        Ambiguities over chattels, fixtures, and rented equipment (e.g., hot water tanks, 
        security systems) are common in FSBO transactions.
        <br/><strong class="bold">Action:</strong> Confirm all inclusions and exclusions 
        in writing within the Contract of Purchase and Sale. Verify any rental agreements 
        or equipment leases with the Seller to avoid unexpected liabilities.
        <br/><br/>
      
        <strong>Compliance with Zoning, Permits, and Renovations</strong><br/>
        FSBO Sellers may not disclose unpermitted renovations, non-conforming uses, or 
        zoning issues that could affect financing or insurance.
        <br/><strong class="bold">Action:</strong> Ask for copies of building permits, 
        occupancy certificates, or inspection reports for any renovations. Confirm zoning 
        compliance with the local municipality and consult with the Buyer’s lawyer on 
        potential risks before removing subjects.
        <br/><br/>
      
        <strong>Communication and Paperwork Coordination</strong><br/>
        Without a listing agent, logistics such as delivering offers, counters, and obtaining 
        signatures require additional diligence and documentation.
        <br/><strong class="bold">Action:</strong> Establish clear timelines, methods of 
        communication, and procedures for document exchange. Keep all interactions and 
        confirmations in writing for transparency and compliance.
        <br/><br/>
      
        <strong>Title Review and Legal Support</strong><br/>
        FSBO Sellers may not be aware of existing encumbrances, liens, easements, or 
        right-of-way agreements registered on title.
        <br/><strong class="bold">Action:</strong> Involve a real estate lawyer early in 
        the process. Order a current title search to confirm ownership and 
        identify any registered encumbrances. Have the lawyer review 
        for issues such as judgments, builder's liens, or restrictive covenants before 
        removing subject conditions.
        <br/><br/>
      
        <strong>Deposits and Trust Handling</strong><br/>
        FSBO transactions sometimes lack a formal brokerage trust account for deposits.
        <br/><strong class="bold">Action:</strong> Ensure deposits are held in trust by a 
        licensed brokerage or the Buyer’s lawyer’s trust account, never directly by the Seller. 
        This protects client funds and ensures compliance with BCFSA standards.
        <br/><br/>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Verification</strong><br/>
        FSBO Sellers may be unaware of conditional periods or lender needs.
        <br/><strong class="bold">Action:</strong> Explain conditional financing 
        clauses and timelines clearly to the Seller in writing.
        <br/><br/>
  
        <strong>Commission Agreements</strong><br/>
        Since FSBO Sellers are unrepresented, commission expectations should be 
        clarified early to avoid disputes.
        <br/><strong class="bold">Action:</strong> Discuss commission arrangements before 
        showing the property. If the Seller declines to include commission in the purchase 
        price, prepare your Buyer for the possibility of paying your fee directly. 
        Ensure any agreement is documented in writing per BCFSA requirements.
        <br/><br/>

        <strong>Mortgage Pre-Approval</strong><br/>
      A pre-approval helps strengthen your client's offer and identifies a clear 
      budget.
      <br/><strong class="bold">Action:</strong> Encourage clients to secure pre-approval 
      from a qualified lender or mortgage broker before beginning their home search. 
      Provide at least three independent mortgage professional referrals to help them 
      make an informed choice based on their needs.
      <br/><br/>

      <strong>Appraisal Requirements</strong><br/>
      Lenders often require a professional appraisal to ensure the property value aligns 
      with the proposed mortgage amount — especially important in FSBO transactions 
      where pricing may not reflect comparable market data.      <br/><strong class="bold">Action:</strong> Work with the lender to schedule a 
      timely appraisal post-conditional acceptance.
      <br/><br/>

      <strong>Deposit Amount</strong><br/>
      Deposits for resale homes typically range from 5-10% of the purchase price and held in the 
      Buyer Brokerage's trust account.
      <br/><strong class="bold">Action:</strong> Discuss a deposit strategy with your 
      client, factoring in local market competitiveness.
      <br/><br/>
      `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Has the Seller done any renovations that require a permit?</li>
        <li>Are there any known defects, renovations, or unpermitted work?</li>
        <li>Is the Seller aware of their legal obligations?</li>
        <li>What is the Seller's expected closing date and reason for selling?</li>
        <li>Has the property been professionally appraised or assessed?</li>
        <li>What utilities, service providers, and warranties are in place?</li>
        <li>Is there a current survey or property boundary map available?</li>
        <li>Are there any easements, right-of-ways, or title issues?</li>
        <li>Will the Seller cooperate with requests for documents or inspections?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        In BC, Buyers also have the right to rescind a contract within 3 business days under the Home Buyer Rescission Period (HBRP).
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "tenantedProperty",
    title: "Residential (Tenant - Vacant Possession)",
    description: `<p>
    When purchasing a residential resale property that is currently 
    tenanted, Buyers seeking vacant possession must navigate both the terms of the 
    tenancy and the requirements under the <a
    href="https://www.ontario.ca/laws/statute/06r17"
    target="_blank"
    rel="noopener noreferrer"
    >Residential Tenancies Act (RTA)</a>. 
    Vacating tenants is not as simple as including a clause in the offer — legal 
    notice/agreements must be served/signed and specific criteria met. 
    Understanding the required processes and procedures of the <a
    href="https://tribunalsontario.ca/ltb/"
    target="_blank"
    rel="noopener noreferrer"
    > Landlord and Tenant Board (LTB)</a> is critical for serving your client's best 
    interests.
    <br/><br/>
    REALTORS® must advise Buyers on the lawful process to obtain vacant possession and 
    ensure the Seller can fulfill their obligations. Failure to handle tenant 
    termination correctly can delay closing or lead to litigation.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all
    situations. REALTORS® are expected to perform proper due diligence and advocate for
    their clients, in line with professional standards. If it's your first time
    handling this type of deal, working with a more experienced REALTOR® is strongly
    recommended—not only to protect your client's best interests and ensure
    competent service, but also to benefit from the opportunity to learn from their
    experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) or Residential Condo (Resale) 
        section, as many of those considerations will apply to this scenario as well. 
        For tenanted properties where vacant possession is needed, here are some 
        additional items to consider.
        <br/><br/>
        <strong>Tenant Rights Under the Law</strong><br/>
        Tenants have strong protections and cannot be forced to leave without lawful 
        notice and valid reason.
        <br/><strong class="bold">Action:</strong> Confirm with the 
        Listing Agent/Seller the status of the tenancy: lease term, rent amount, start 
        date, and any renewal terms. Inquire if the N11 - Agreement to End Tenancy 
        has already been signed and obtain a copy.
        <br/><br/>

        <strong>Assuming the Tenancy</strong><br/>
        If the Tenant is not cooperative, the Buyer may choose to assume the tenancy 
        and deal with the tenant directly in order to obtain vacant possession. This 
        scenario could lead to months before vacant possession is achieved. Once the 
        Buyer has closed and assumed the tenancy, the Seller is no longer responsible. 
        This is rarely an acceptable option to the Buyer, but it is an option.
        <br/><strong class="bold">Action:</strong> Discuss the risks of assuming the 
        tenancy with your client. If they choose to assume the tenancy, you should 
        recommend they engage a lawyer to review the lease and ensure they 
        are protected. Any damages to the property will be the responsibility of the 
        Buyer once the property is in their possession.
        <br/><br/>
  
        <strong>Buyer's Own Use Notice (Form N12)</strong><br/>
        To obtain vacant possession for Buyer's own use, the Seller must serve an N12 
        notice with at least 60 days' notice from the start of a rent period, plus 
        offer compensation or an alternative unit.
        <br/><strong class="bold">Action:</strong> Confirm that the Seller can 
        legally issue the N12 and that the closing date accommodates the required 
        notice period. Advise your client that vacant possession is not 
        guaranteed—tenants may refuse to leave, and Landlord and Tenant Board (LTB) 
        hearings can take months to resolve.
        <br/><br/>
  
        <strong>Use of N12 Must Be Genuine</strong><br/>
        Buyer must genuinely intend to move into the property or have a qualified 
        family member do so and reside there for at least one year.
        <br/><strong class="bold">Action:</strong> Make sure the Buyer understands the 
        legal declaration involved and risks of bad faith termination (including 
        tribunal fines).
        <br/><br/>

        <strong>Agreement to End Tenancy (Form N11)</strong><br/>
        An N11 is a mutual agreement between the landlord and tenant to end the 
        tenancy on a specific date. It is generally more reliable than serving an 
        N12, as it does better at avoiding potential disputes or delays through the 
        Landlord and Tenant Board (LTB).
        <br/><strong class="bold">Action:</strong> Where possible, negotiate an N11 
        signed by the tenant before firming up the deal. Confirm the agreed-upon 
        vacancy date and attach the signed form as part of the offer documentation.
        <br/><br/>
  
        <strong>Lease Type (Fixed-Term vs. Month-to-Month)</strong><br/>
        Fixed-term tenants cannot be evicted before the end of their term unless they 
        voluntarily agree (N11). Month-to-month tenants can be served with N12 if notice 
        conditions are met. However, even with proper notice, the tenant may still 
        choose not to vacate, potentially leading to a dispute and requiring a 
        hearing at the Landlord and Tenant Board (LTB) to enforce eviction.
        <br/><strong class="bold">Action:</strong> Confirm the Seller has met all 
        legal requirements for issuing the N12. Advise your client of the risks and 
        potential delays if the tenant contests the notice or refuses to leave. 
        Strongly recommend including a signed N11 condition in the offer, as it is 
        the most effective way to try and obtain vacant possession.
        <br/><br/>

        <strong>Future Rental Compliance</strong><br/>
        If the Buyer intends to rent out unit(s) in the future, it is essential 
        to confirm that the units are legally permitted for rental use.
        <br/><strong class="bold">Action:</strong> Verify zoning, licensing, and any 
        municipal regulations that apply to the property to ensure compliance. 
        Proceeding without confirming legality could result in fines, penalties, 
        restrictions on rental use, and litigation. It is critical that you conduct 
        proper due diligence to ensure the property can be used as intended. Strongly 
        recommend obtaining written confirmation of legal rental status before 
        finalizing the offer.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Pre-Approval</strong><br/>
        Lenders may assess not only the Buyer but also the building's financial 
        health.
        <br/><strong class="bold">Action:</strong> Connect your client with a 
        trusted mortgage broker or lender before house hunting. Offer them a minimum 
        of three lender referrals and encourage open conversations with each, 
        allowing them to make the most informed choice based on their needs.
        <br/><br/>
  
        <strong>Appraisal Process</strong><br/>
        Lenders typically require an appraisal to confirm property value 
        aligns with loan amount.
        <br/><strong class="bold">Action:</strong> Work with the lender to schedule 
        a timely appraisal post-conditional acceptance.
        <br/><br/>
  
        <strong>Deposit Considerations</strong><br/>
        Deposits typically range between 5-10% of the purchase price.
        <br/><strong class="bold">Action:</strong> Strategize with your client on 
        deposit size based on competition and financing strength.
        `,
      },
      {
        title: "Offer Strategy & Legal Support",
        text: `
       Engaging a lawyer early and having them review the offer is critical. 
       Include a lawyer review condition, as each situation can be unique and may 
       require a tailored approach. 
       <br/><br/>

        <strong>Condition for Vacant Possession</strong><br/>
        The offer should clearly state that vacant possession is required on closing 
        and contain condition(s) that are reasonable and achievable in the specific 
        circumstance.
        <br/><strong class="bold">Action:</strong> Recommend your clients  
        engage a lawyer to confirm notice timelines, lease implications, 
        and proper documentation. It is important to have a lawyer who is 
        experienced with this type of transaction.
        <br/><br/>
  
        <strong>Vacant Possession - Cash for Keys Option</strong><br/>
        This approach may be necessary if other methods to obtain vacant possession 
        are not viable. It involves negotiating a financial settlement with the 
        tenant in exchange for them agreeing to vacate the unit.
        <br/><strong class="bold">Action:</strong> Talk with your clients about 
        potentially offering to share the cost with the Seller if a cash-for-keys 
        arrangement is the only option. An N11 agreement must be signed to properly 
        document the tenant's consent to vacate. Legal guidance is strongly advised 
        to ensure compliance with all requirements. 
        <br/><br/>
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the tenancy fixed-term or month-to-month?</li>
        <li>Has an N11 been signed by the tenant? When is the agree-upon
        vacancy date?</li>
        <li>Is the tenant aware of the situation and cooperative?</li>
        <li>Is there enough time between firm deal and closing for the N12 period?</li>
        <li>Has a real estate lawyer reviewed the lease and notice?</li>
        <li>What happens if the tenant refuses to leave? Are there conditions in the 
        offer that address this?</li>
        <li>Are there any tribunal proceedings or complaints underway that may 
        prevent the sale from closing?</li>
        </ol>
        `,
      },
      {
        title: "Common Clauses and Conditions",
        text: `
        <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all BCFSA approved forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      Review the <a
      href="/ON/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

      <strong>Buyer Lawyer Review Condition</strong><br/>
      This is a very important condition to include in the offer, as it will give 
      the opportunity to review the transaction with a lawyer. Based on the unique 
      circumstances of the transaction, the lawyer may recommend additional conditions 
      or clauses to be included in the offer. Additionally, the lawyer can review the 
      vacant possession condition noted below.
      <br/><br/>
  
      <strong>Vacant Possession Condition</strong><br/>
      The Buyer hereby authorizes and directs the Seller, and the Seller agrees, 
      when this Agreement becomes unconditional, to give the tenant(s) the requisite 
      notices under the existing Residential Tenancies Act (RTA), requiring vacant 
      possession of the property effective _________________(closing date).  The 
      Seller further agrees to provide to the Buyer copies of the requisite notices 
      sent to, received by, and acknowledged by the tenant in this regard.  In the 
      event that the Tenant fails to vacate the property on or 
      before _________________ (closing date),  the Buyer shall have the option, in 
      the Buyer's sole and absolute discretion, to extend the Closing Date set 
      herein up to ten (10) business days in order to obtain vacant possession set 
      out in this agreement, failing which, the Buyer shall have the option, in the 
      Buyer's sole and absolute discretion, to terminate the transaction, and the 
      deposit shall be returned to the Buyer in full forthwith, without deduction.
      <br/><br/>
      This offer is conditional upon the Seller obtaining a signed N11 agreement 
      from the Tenant of the Property to vacate no later than (Insert Date). Unless 
      the Seller gives notice in writing delivered to the Buyer not later than 
      (Insert Date), that this condition is fulfilled, this Offer shall be null and 
      void and the deposit shall be returned to the Buyer in full without deduction. 
      This condition is included for the benefit of the Buyer and may be waived at 
      the Buyer's sole option by notice in writing to the Seller within the time 
      period stated herein.
      <br/><br/>

      Explanation of the above Condition:<br/>
      This clause ensures the Seller is responsible for giving the tenant proper 
      notice to vacate under the Residential Tenancies Act and must provide the 
      Buyer with proof of those notices and any tenant acknowledgments. If the 
      tenant does not vacate by closing, the Buyer can either extend the closing 
      by up to 10 business days or terminate the agreement and receive a full 
      refund of the deposit. The offer is also conditional on the Seller securing 
      a signed N11 - Agreement to End Tenancy by a specific date. If this 
      condition isn't met, the Buyer can cancel the deal without penalty. The 
      10-day extension allows the Seller time to file an L3 application to obtain 
      an expedited eviction order from the Landlord and Tenant Board (LTB). As long 
      as proper procedures have been followed, the LTB will issue the order without 
      a hearing.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "cottage",
    title: "Cottage Property",
    description: `<p>
    Review the Single Family Residential (Resale) section, as many of those 
    considerations will apply to this scenario as well. For cottage properties, 
    here are some additional items to consider.
    <br/><br/>
    Purchasing a cottage typically involves acquiring a seasonal or year-round 
    recreational property, often in rural or remote areas, with unique considerations 
    not typically encountered in urban residential transactions. Buyers must evaluate 
    a multitude of factors such as property access, services, shoreline rights, 
    septic and well systems, and local bylaws.
    <br/><br/>
    REALTORS® must guide clients through the complexities of rural ownership, 
    environmental protections, and seasonal occupancy restrictions. Due diligence is 
    essential to ensure a smooth and informed transaction.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all 
    situations. REALTORS® are expected to perform proper due diligence and advocate  
    for their clients, in line with professional standards. If it's your first time 
    handling this type of deal, working with a more experienced REALTOR® is strongly 
    recommended—not only to protect your client's best interests and ensure 
    competent service, but also to benefit from the opportunity to learn from their 
    experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Seasonal vs. Year-Round Use</strong><br/>
        Cottages may be designated for seasonal use only and lack year-round access or 
        infrastructure (e.g., winterized plumbing, heating, road access/maintenance).
        <br/><strong class="bold">Action:</strong> Review zoning bylaws and official 
        plan designations. Ask the municipality whether the property permits 
        year-round occupancy and whether road access/maintenance is provided year-round.
        <br/><br/>
  
        <strong>Access Type</strong><br/>
        Access may be via municipal roads (maintained), private strata roads, forest 
        service roads, or water-access only (boat-in). Some BC properties rely on 
        logging roads or unmaintained Crown access routes.
        <br/><strong class="bold">Action:</strong> Confirm legal access through title, 
        survey, or a lawyer's review. For private or strata roads, review any road 
        maintenance agreements or strata bylaws. For Crown access, verify permitted use.
        <br/><br/>
  
        <strong>Shoreline Ownership and Rights</strong><br/>
        Waterfront in BC may be privately owned, partially owned, or include a Crown 
        foreshore. In BC, the foreshore (the land between high and low watermarks) is 
        almost always owned by the Province, not the private landowner.
        <br/><strong class="bold">Action:</strong> Confirm property boundaries via the 
        land title survey. Determine whether any portion of the foreshore is leased or 
        licensed. Check for requirements for a dock permit, specific permission for 
        structures, or Crown tenure for moorage.
        <br/><br/>
  
        <strong>Water Source and Quality</strong><br/>
        Cottage water may be sourced from lakes, rivers, wells, community systems, or 
        private water systems. Many recreational properties rely on lake intake systems, 
        which are often non-potable.
        <br/><strong class="bold">Action:</strong> Conduct potability tests and review 
        details of the water system (filtration, UV, seasonal shutoff). If a well is 
        present, confirm whether it is shared and obtain any shared well agreements. 
        Ask when water is typically turned off for winter.
        <br/><br/>
  
        <strong>Septic System or Holding Tank</strong><br/>
        Many recreational properties use private septic systems, holding tanks, or older 
       systems that may not comply with current BC regulations (e.g., under the Sewerage 
       System Regulation).
        <br/><strong class="bold">Action:</strong> Action: Request a septic inspection 
        and system records. Verify whether the system was installed by an Authorized 
        Person and ask the regional health authority about requirements for upgrades 
        or pump-out schedules.
        <br/><br/>
  
        <strong>Heating, Insulation & Winterization</strong><br/>
        Heating may be electric baseboard, propane, or wood stove. Older cottages may 
        lack proper insulation or winter-proofing.
        <br/><strong class="bold">Action:</strong> Confirm heating system type, age, 
        and suitability for year-round use. Assess the risk of frozen pipes or 
        seasonal damage. Inquire with the Listing Agent/Seller for any winterization 
        practices they have in place.
        <br/><br/>
  
        <strong>Environmental Regulations and Conservation Authority</strong><br/>
        Cottages near lakes, rivers, or wetlands in BC may fall under the Riparian 
        Areas Protection Regulation (RAPR) or other environmental restrictions.
        <br/><strong class="bold">Action:</strong> Check with the relevant municipality, 
        regional district, or provincial ministry about restrictions on tree removal, 
        shoreline alteration, docks, additions, and septic replacement near water.
        <br/><br/>
  
        <strong>Local Amenities and Emergency Services</strong><br/>
        Remote locations may have limited emergency access, cell coverage, or 
        convenience services.
        <br/><strong class="bold">Action:</strong> Discuss with the Buyer their 
        expectations and needs (hospital proximity, internet, boat launch, garbage 
        collection, etc.).
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Challenges</strong><br/>
        Financing seasonal properties or water-access-only cottages may require 
        specialized lenders or larger down payments. It is common that a minimum of 
        20% down payment is required for these types of properties.
        <br/><strong class="bold">Action:</strong> Connect clients early with a 
        mortgage broker familiar with rural and recreational property lending.
        <br/><br/>
  
        <strong>Appraisals for Unique Properties</strong><br/>
        Appraisals can be difficult if few comparable properties exist, especially on 
        islands or with irregular features.
        <br/><strong class="bold">Action:</strong> Work with lenders to support the 
        appraisal and prepare your client for potential value discrepancies.
        <br/><br/>
  
        <strong>Insurance Availability</strong><br/>
        Insuring remote or seasonal cottages in BC can be difficult due to wildfire 
        exposure, limited emergency response, wood-burning appliances, or boat-only 
        access. Some insurers exclude high-risk wildfire zones or require specific 
        certifications for wood stoves.
        <br/><strong class="bold">Action:</strong> Obtain insurance quotes early and 
        confirm that coverage is available and affordable before removing subjects.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <strong>Additional Common Questions</strong><br/>
        <ol>
        <li>Is the property zoned for seasonal or year-round use, and does it comply 
        with the Official Community Plan (OCP)?</li>
        <li>What type of access does the property have? Are maintenance obligations 
        clearly defined?</li>
        <li>Who owns the foreshore/shoreline? Are there permits, leases, or licenses 
        required for docks, boathouses, or other structures?</li>
        <li>What is the water source, and is it potable year-round? If a well is shared, 
        is there a formal agreement?</li>
        <li>What type of septic or holding tank system exists, and does it meet current 
        BC health authority regulations?</li>
        <li>What heating, insulation, and winterization measures are in place, and are 
        they adequate for year-round use?</li>
        <li>Are there environmental or riparian regulations affecting the property 
        (Riparian Areas Protection Regulation, wetlands, or tree-cutting restrictions)?</li>
        <li>Are utilities, emergency services, and communications reliable year-round?</li>
        <li>Can the Buyer obtain mortgage financing for this type of recreational 
        property?</li>
        <li>Is insurance available and affordable for the property's location, access 
        type, and risk factors (wildfire, water proximity, wood stoves)?</li>
        <li>Are there any restrictions on resale or subdivision, and are there shared 
        maintenance or strata agreements?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        In BC, Buyers also have the right to rescind a contract within 3 business days under the Home Buyer Rescission Period (HBRP).
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "preconfreehold",
    title: "Pre-Construction (Freehold)",
    description: `
    Purchasing a pre-construction freehold home in Ontario — such as a detached, 
    semi-detached, or townhome — means entering into a contract to buy a newly built 
    property directly from a builder before it's completed. These transactions differ 
    from resale or pre-construction condo purchases in terms of structure, fees, and 
    closing timelines.
    <br/><br/>
    REALTORS® must help Buyers navigate builder contracts, occupancy dates, deposits, 
    and hidden costs. Legal review and clear communication around delays, warranties, 
    and municipal approvals are essential to protect the Buyer's investment and 
    expectations.
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Firm Closing vs. Tentative Timelines</strong><br/>
        Pre-construction freeholds typically don't have interim occupancy like condos, 
        but the final closing date is often tentative and may change.
        <br/><strong class="bold">Action:</strong> Review all builder documents for 
        language about extension rights and critical dates. Prepare clients for 
        potential delays in closing.
        <br/><br/>
  
        <strong>HST and Rebate Clarification</strong><br/>
        HST is typically included in advertised prices, but Buyers must qualify for 
        the New Home Rebate if they intend to live in the property.
        <br/><strong class="bold">Action:</strong> Confirm whether the builder or 
        Buyer is applying for the rebate and explain consequences if the Buyer is
        an investor. Have the client consult their lawyer/tax accountant to confirm 
        any HST implications.
        <br/><br/>
  
        <strong>Deposit Structure</strong><br/>
        Deposits are usually paid in installments (e.g., 5% at signing, 5% in 60 days).
        <br/><strong class="bold">Action:</strong> Review the payment schedule with the 
        Buyer to ensure they have access to funds as required.
        <br/><br/>
  
        <strong>Development Charges and Closing Costs</strong><br/>
        Freehold homes often come with uncapped development charges and levies.
        <br/><strong class="bold">Action:</strong> Negotiate caps on these fees where 
        possible and clarify all potential closing adjustments upfront.
        <br/><br/>
  
        <strong>Driveways, Landscaping, and Grading</strong><br/>
        Exterior features like driveways, sod, fences, or grading may not be complete 
        on closing.
        <br/><strong class="bold">Action:</strong> Confirm with the builder what will 
        be completed at occupancy and what may be delayed until seasonal conditions 
        permit.
        <br/><br/>
  
        <strong>Builder Reputation and Track Record</strong><br/>
        The quality and consistency of the builder can affect timelines, finish quality, 
        and service after closing.
        <br/><strong class="bold">Action:</strong> Research the builder's past projects, 
        online reviews, and Tarion record (warranty history and disputes).
        <br/><br/>
  
        <strong>Tarion Warranty Program</strong><br/>
        New freehold homes are covered under the Tarion New Home Warranty, offering 
        protection for up to 7 years.
        <br/><strong class="bold">Action:</strong> Explain the warranty coverage and 
        key deadlines (e.g., 30-day, 1-year, 2-year, and 7-year claims).
        `,
      },
      {
        title: "Financing & Construction Considerations",
        text: `
        <strong>Mortgage Pre-Approval Limitations</strong><br/>
        Most lenders won't finalize a mortgage more than 120 days before closing.
        <br/><strong class="bold">Action:</strong> Encourage clients to obtain 
        pre-qualification now and revisit full approval closer to closing.
        <br/><br/>
  
        <strong>Construction Delays and Critical Dates</strong><br/>
        Builders may legally extend the construction timeline under Tarion's critical 
        date framework.
        <br/><strong class="bold">Action:</strong> Review Tarion's Addendum and explain 
        Firm, Tentative, and Outside Closing Dates.
        <br/><br/>
  
        <strong>Appraisal at Time of Closing</strong><br/>
        The lender will typically require an appraisal close to closing to ensure the 
        value matches the purchase price.
        <br/><strong class="bold">Action:</strong> Advise Buyers of possible appraisal 
        shortfalls and the need for a financing buffer.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What is the current construction status and projected closing date?</li>
        <li>Are development charges and levies capped in the agreement?</li>
        <li>What finishes are standard vs. upgrades?</li>
        <li>Is HST included in the purchase price, and who is claiming the rebate?</li>
        <li>Will the driveway, sod, or grading be completed before closing?</li>
        <li>Are there any known delays in permits, servicing, or municipal approvals?</li>
        <li>What builder warranties and after-sale services are included?</li>
        <li>What are the builder's policies on assignment or alterations?</li>
        <li>Is the home registered under the Tarion Warranty Program?</li>
        </ol>
        `,
      },
      {
        title: "Common Conditions and Clauses",
        text: `
        <p>
        <strong>10-Day Cooling-Off Period (Builder-Dependent)</strong><br/>
        While not required by law for freehold homes (unlike condos), some builders 
        offer this. Always check the contract.
        <br/><br/>
  
        <strong>Lawyer Review Condition</strong><br/>
        Critical due to the complexity of builder APS agreements and Tarion Addendum.
        <br/><br/>
  
        <strong>Financing Condition</strong><br/>
        Provides time for Buyers to confirm affordability and mortgage terms.
        <br/><br/>
  
        <strong>Closing Cost Cap Clause</strong><br/>
        If not already included, negotiate a clause limiting the Buyer's exposure to 
        development charges and builder fees.
        <br/><br/>
  
        <strong>Other Useful Clauses and Considerations</strong>
        <ol>
          <li>HST clause specifying responsibility for rebate qualification</li>
          <li>Assignment clause (if allowed) outlining fees and timelines</li>
          <li>Confirmation of Tarion registration and warranty enrollment</li>
          <li>Upgrade list review and confirmation of selections</li>
          <li>Builder walkthrough or deficiency inspection rights prior to closing</li>
        </ol>
        </p>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "indigenousLand",
    title: "Purchase on First Nations Land (Leased Land)",
    description: `<p>
    Purchasing property on First Nations lands is significantly different from 
    traditional freehold or condo transactions. Most properties located on 
    First Nations lands are not owned in fee simple but instead fall under First Nations 
    jurisdiction via the Indian Act or their own Land Code (FNLMA). Buyers generally acquire a leasehold interest that must be approved by 
    the Band Council, and depending on the community’s governance structure, may also 
    require oversight or registration through Indigenous Services Canada (ISC) or 
    administration under the First Nations Land Management Act (FNLMA).
    <br/><br/>
    REALTORS® must understand the legal and financial frameworks that govern First Nations 
    land transactions, including lease terms, community consent, lender requirements, 
    and restrictions on resale or development. Legal counsel and mortgage brokers 
    familiar with First Nations land structures are critical to protecting Buyer interests.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all 
    situations. REALTORS® are expected to perform proper due diligence and advocate  
    for their clients, in line with professional standards. If it's your first time 
    handling this type of deal, working with a more experienced REALTOR® is strongly 
    recommended—not only to protect your client's best interests and ensure 
    competent service, but also to benefit from the opportunity to learn from their 
    experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those  
        considerations will apply to this scenario as well. 
        For properties on First Nations land, here are some additional items to consider.
        <br/><br/>

        <strong>Ownership Structure: Leasehold vs. Freehold</strong><br/>
        Most real estate on First Nations land is not sold in fee simple. Instead, 
        non-Indigenous Buyers typically obtain leasehold interests granted and 
        approved by the First Nation and sometimes Indigenous Services Canada (ISC), 
        depending on the land management regime.
        <br/><strong class="bold">Action:</strong> Determine whether the property is 
        on First Nations land, identify the type of leasehold (CP—Certificate of Possession, 
        Head Lease, Sublease), confirm remaining lease term, and verify whether ISC 
        approval is required based on the governing framework (FNLMA or Indian Act).
        <br/><br/>
  
        <strong>Band Council and ISC Approval</strong><br/>
        Transactions may require approval from the First Nation’s Band Council. ISC 
        approval is required only if the land is managed under the Indian Act (not for 
        First Nations operating under FNLMA).
        <br/><strong class="bold">Action:</strong> Engage early with the Band Council 
        or land management office to confirm required approvals, timelines, and any 
        applicable transfer fees or administrative costs.
        <br/><br/>
  
        <strong>Land Management Regime (Indian Act, MATR, or FNLMA)</strong><br/>
        Some First Nations operate under the First Nations Land Management Act (FNLMA), 
        allowing them to manage land and leases independently of ISC. Others still 
        follow the Indian Act or a land code under the First Nations Land Management 
        Regime (FNLMA).
        <br/><strong class="bold">Action:</strong> Confirm whether the community 
        operates under the Indian Act, FNLMA, FNLMR, or a land code, as this affects 
        leasing procedures, mortgage eligibility, enforcement rights, and resale 
        requirements.
        <br/><br/>
  
        <strong>Length and Conditions of Lease</strong><br/>
        Leasehold terms typically range from 25 to 99 years, often with renewal 
        clauses, rent escalation terms, and restrictions on property use or 
        modifications.
        <br/><strong class="bold">Action:</strong> Review the lease agreement in 
        detail with a lawyer familiar with First Nations land and federal leasehold 
        transactions.
        <br/><br/>
  
        <strong>Community Rules, Bylaws & Infrastructure</strong><br/>
        Communities may impose their own bylaws for development, noise, septic systems, 
        and occupancy.
        <br/><strong class="bold">Action:</strong> Clarify with the Band Council or 
        property manager any relevant regulations, service limitations, or 
        infrastructure constraints.
        <br/><br/>
  
        <strong>Resale and Inheritance Restrictions</strong><br/>
        Leases on First Nations land often require Band approval for resale or 
        assignment. Some communities restrict resale to approved Buyers (e.g., Band 
        members or pre-approved non-members). Leasehold interests may have inheritance
        restrictions and may not transfer automatically without consent.
        <br/><strong class="bold">Action:</strong> Ensure the Buyer is aware of 
        assignment and resale limitations, especially for investment or long-term 
        family planning.
        `,
      },
      {
        title: "Financing, Legal, and Insurance",
        text: `
        <strong>Financing Challenges on First Nations Land</strong><br/>
        Most conventional lenders are unwilling to finance properties on First Nations 
        land, making it harder for Buyers to secure a mortgage.
        <br/><strong class="bold">Action:</strong> Encourage your client to consult 
        a mortgage broker who specializes in this type of financing. They can help 
        navigate lender requirements and confirm whether the leasehold property is 
        eligible for mortgage approval.
        <br/><br/>
  
        <strong>Title and Leasehold Interest</strong><br/>
        On First Nations land, title is often held by the Crown (Gov't of Canada) or the 
        First Nation, depending on whether the community operates under the Indian Act 
        or its own Land Code (FNLMA). Buyers generally hold a 
        leasehold interest rather than full ownership.
        <br/><strong class="bold">Action:</strong> Ensure legal counsel experienced in 
        First Nations or Federal leasehold transactions explains the lease structure, 
        confirms enforceability, reviews consent requirements, and verifies that the 
        lease is properly registered in the appropriate registry (ISC or First Nation 
        Land Registry).
        <br/><br/>
  
        <strong>Insurance and Risk Considerations</strong><br/>
        Insuring properties on First Nations land may require additional documentation 
        and approval from both insurer and Band.
        <br/><strong class="bold">Action:</strong> Obtain insurance quotes early and 
        verify eligibility with underwriters who support leasehold or rural 
        properties.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>Is the property located on First Nations land, settlement land, or land governed under a First Nation Land Code?</li>
          <li>What is the full lease term, how many years remain, and does it meet lender minimum requirements?</li>
          <li>Are there restrictions on resale, assignment, or inheritance under the lease or Band rules?</li>
          <li>What approvals are required from the Band Council, First Nation administration, or Indigenous Services Canada (ISC)?</li>
          <li>What bylaws, land use regulations, or community rules govern development, occupancy, and renovations?</li>
          <li>Are utilities, roads, fire protection, and emergency services provided municipally, privately, or by the First Nation?</li>
          <li>Can the Buyer obtain mortgage financing and home insurance for this specific leasehold structure?</li>
          <li>Is the lease registered with ISC or the First Nation Land Registry, and is the registration current?</li>
          <li>Are there any active or pending land claims, disputes, or rights-of-way that may affect the property?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
      <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        Buyers do not have Rescission Rights when purchasing property on First Nations
        land.
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "mobileManufactured",
    title: "Mobile, Manufactured, and Modular Home",
    description: `<p>
    Purchasing a mobile, manufactured, or modular home requires a unique 
    understanding of construction types, land ownership structures, and regulatory 
    compliance. These homes may be located on leased land (in mobile home parks or 
    land lease communities), or on privately owned lots with full title.
    <br/><br/>
    REALTORS® must help Buyers differentiate between these housing types, assess 
    financing eligibility, confirm land tenure, and understand the applicable building 
    and zoning standards. Attention to detail in disclosures, insurance, and 
    construction certification is critical to protect the Buyer.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <p>
        <strong>Mobile vs. Manufactured vs. Modular</strong><br/>
        These terms are often used interchangeably, but have specific meanings in BC:
        <br/>
        <strong>Mobile:</strong> Older homes (generally pre-1976) built to standards 
        that may not meet modern building or safety codes. Often on a steel chassis 
        with wheels and may not be CSA-certified.<br/>
        <strong>Manufactured:</strong> Factory-built homes constructed to 
        CSA Z240 MH standards and usually placed on either owned 
        or leased land.<br/>
        <strong>Modular:</strong> Factory-built sections assembled on-site and built 
        to CSA A277 or the BC Building Code. Often comparable to 
        traditional site-built homes once installed.<br/>
        <strong class="bold">Action:</strong> Verify the type of home and confirm the 
        presence of a valid CSA certification label or documentation. If missing, 
        consult a qualified home inspector or engineer for compliance verification.
        <br/><br/>
      
        <strong>Land Ownership vs. Pad Lease</strong><br/>
        Many manufactured homes are situated in land lease (mobile home park) 
        communities, while others are on privately owned land.
        <br/><strong class="bold">Action:</strong> Determine whether your client is 
        purchasing both the home and the land (freehold) or just the home on a 
        leased pad. For leasehold properties, review the tenancy or park agreement 
        for fees, term length, and restrictions under the 
        <em>Manufactured Home Park Tenancy Act</em>.
        <br/><br/>
      
        <strong>Park or Land Lease Community Rules</strong><br/>
        Manufactured home parks in BC are governed by strict community rules regarding 
        occupancy, age limits, pets, resale, and maintenance.
        <br/><strong class="bold">Action:</strong> Obtain and review the park rules, 
        tenancy agreement, and approval requirements from the park manager before 
        removing subjects. Many parks require Buyer approval prior to sale.
        <br/><br/>
      
        <strong>Zoning and Bylaw Compliance</strong><br/>
        Not all municipalities permit manufactured or mobile homes in every zoning area.
        <br/><strong class="bold">Action:</strong> Verify with the local municipality 
        or regional district that the property and home comply with zoning, building, 
        and siting regulations. Ensure any additions, decks, or extensions were 
        properly permitted.
        <br/><br/>
      
        <strong>Utilities and Infrastructure</strong><br/>
        Manufactured homes may rely on private systems for water, sewage, or power, 
        especially in rural areas.
        <br/><strong class="bold">Action:</strong> Confirm all utility connections 
        (hydro, propane, septic, or community water) and request copies of recent 
        inspection reports for wells or septic systems. Ask about any recurring 
        service disruptions or park utility fees.
        <br/><br/>
      
        <strong>Age, Condition, and Safety</strong><br/>
        Older mobile homes may not meet current safety, electrical, or insulation 
        standards, which can affect financing and insurance eligibility.
        <br/><strong class="bold">Action:</strong> Order a comprehensive inspection by 
        an inspector familiar with manufactured homes. Confirm that electrical systems 
        comply with current BC Safety Authority (Technical Safety BC) standards and 
        that the home’s underside, skirting, and anchoring are in safe condition.
        <br/><br/>
      
        <strong>Registration & Taxes</strong><br/>
        Manufactured homes on leased pads are typically registered in the 
        Manufactured Home Registry (MHR), while those on owned land are registered 
        through the  Land Title and Survey Authority (LTSA).
        <br/><strong class="bold">Action:</strong> Confirm registration type and 
        ownership status. If the home is on leased land, check that the MHR decal and 
        registration number match the records and that taxes are current.
        <br/><br/>

        <strong>Title and Ownership Documents</strong><br/>
        In BC, manufactured homes may be registered as either personal property 
        (through the MHR) or as real property (through LTSA) if attached to owned land.
        <br/><strong class="bold">Action:</strong> Confirm the legal ownership status, 
        serial number, and registration type. Work with a lawyer to ensure all transfers 
        are properly registered in the appropriate system (MHR or LTSA) and that 
        applicable taxes have been paid.
        <br/><br/>
        <strong>Electrical Compliance & Silver Label</strong><br/>
        Homes that have been relocated, renovated, or lack visible CSA certification 
        must have a valid Technical Safety BC Silver Label affixed. This label 
        confirms that a licensed electrical contractor has inspected and upgraded 
        the electrical system to meet current 
        safety standards.<br/>
        <strong class="bold">Action:</strong> Verify the presence and number of the Silver Label. 
        If missing, advise the Buyer to contact Technical Safety BC or a licensed 
        electrical contractor to arrange inspection and certification prior to 
        completion or insurance application.
        <br/><br/>
        </p>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Financing Challenges</strong><br/>
        Financing options for manufactured and mobile homes depend on land ownership, 
        CSA certification, and foundation type. Homes on leased land or without 
        permanent foundations may not qualify for conventional mortgages.
        <br/><strong class="bold">Action:</strong> Refer clients to mortgage brokers 
        experienced with manufactured housing and land lease lending. Alternative 
        financing (e.g., chattel loans or credit unions) may be necessary.
        <br/><br/>
      
        <strong>CSA Certification & Lender Requirements</strong><br/>
        Lenders often require proof of CSA Z240 or CSA A277 certification and 
        confirmation that the home is permanently affixed and properly anchored.
        <br/><strong class="bold">Action:</strong> Confirm CSA certification numbers 
        and installation records. If unavailable, advise the Buyer to consult an 
        engineer for re-certification or compliance verification, as required by 
        the lender or insurer.
        <br/><br/>
      
        <strong>Insurance Availability</strong><br/>
        Insurance can be limited or more expensive for older or uncertified mobile homes.
        <br/><strong class="bold">Action:</strong> Obtain a home insurance quote early. 
        Verify whether coverage includes the dwelling, contents, and liability, and 
        whether the insurer requires CSA compliance or upgrades before issuing a policy.
        <br/><br/>
      
        <strong>Appraisal & Valuation</strong><br/>
        Appraising manufactured homes requires specialized knowledge due to differing 
        depreciation, site conditions, and land lease terms.
        <br/><strong class="bold">Action:</strong> If needed, arrange for an appraiser with 
        experience in manufactured housing. Provide the lender with all park or lease 
        details to ensure an accurate valuation and smoother financing process.
        <br/><br/>
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What type of home is it: mobile, manufactured, or modular?</li>
        <li>Is the home CSA certified, and what is the certification type?</li>
        <li>Is the land included in the purchase?</li>
        <li>What are the park or lease fees, and what do they include?</li>
        <li>What utilities are available and who are the service providers?</li>
        <li>Are there age or use restrictions within the community?</li>
        <li>Are pets or rentals allowed in the park?</li>
        <li>Can I secure mortgage financing or must I pay cash?</li>
        <li>Are there resale or transfer restrictions set by the park owner?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
         <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        In BC, Buyers also have the right to rescind a contract within 3 business days 
        under the Home Buyer Rescission Period (HBRP). This does not apply for properties 
        located on leased land or rental pads. 
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        <br/><br/>

      <strong>Common Conditions/Clauses worth noting for this type of transaction:</strong><br/>
      <ol>
      <li>Financing Condition: Especially critical if the property is in a land 
      lease community or lacks a traditional foundation</li>
      <li>Lawyer Review of Lease or Park Rules: Essential for leasehold purchases 
      to review the lot lease agreement, rights, and obligations</li>
      <li>Insurance availability and premium confirmation</li>
      </ol>
      <br/>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "crownLand",
    title: "Purchase on Crown Land (Leased Land)",
    description: `
    Purchasing a residential property on Crown Land in Ontario involves acquiring a 
    structure or leasehold interest on land that is owned and managed by the 
    provincial or federal government. Buyers must understand that Crown land cannot be 
    privately owned in most cases, and transactions typically involve leasehold 
    arrangements governed by strict rules, renewal conditions, and development 
    restrictions.
    <br/><br/>
    REALTORS® must ensure Buyers understand the limitations of Crown land ownership, 
    legal implications of leasehold tenure, and the risks associated with financing, 
    resale, and land use. Legal counsel and early contact with the appropriate 
    government authority are essential.
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Ownership Limitations</strong><br/>
        Crown Land is owned by the provincial or federal government and cannot be 
        purchased outright. Residential use is usually granted through long-term leases, 
        licenses of occupation, or permits.
        <br/><strong class="bold">Action:</strong> Confirm the type of tenure involved 
        (lease, permit, license) and the length, renewal terms, and conditions of use.
        <br/><br/>
  
        <strong>Government Authority and Oversight</strong><br/>
        In Ontario, Crown land is typically managed by the Ministry of Natural Resources 
        and Forestry (MNRF) or Parks Canada (in federal territories).
        <br/><strong class="bold">Action:</strong> Contact MNRF or the relevant federal 
        agency to verify the lease's legitimacy, current standing, and any pending 
        changes.
        <br/><br/>
  
        <strong>Lease Conditions and Restrictions</strong><br/>
        Lease agreements may prohibit year-round use, restrict renovations, or limit 
        resale/transfer rights.
        <br/><strong class="bold">Action:</strong> Carefully review the lease terms with 
        a real estate lawyer. Confirm usage rights, seasonal restrictions, and 
        requirements for maintaining the property.
        <br/><br/>
  
        <strong>Transferability and Sale Approvals</strong><br/>
        Transfers of leasehold interests on Crown land often require government approval 
        and may be delayed or denied depending on lease terms or policy changes.
        <br/><strong class="bold">Action:</strong> Request all current lease documents 
        and confirm transfer procedures with the managing authority.
        <br/><br/>
  
        <strong>Improvements and Permits</strong><br/>
        Any development, alteration, or expansion may require additional approvals from 
        the Crown or environmental authorities.
        <br/><strong class="bold">Action:</strong> Ensure all existing improvements were 
        permitted. Review policies on adding docks, septic systems, solar panels, or 
        boathouses.
        <br/><br/>
  
        <strong>Environmental Sensitivity and Conservation Policies</strong><br/>
        Crown lands often include protected shorelines, wetlands, or wildlife corridors 
        with strict development controls.
        <br/><strong class="bold">Action:</strong> Inquire about environmental 
        assessments, local conservation authority jurisdiction, and protected species 
        restrictions.
        `,
      },
      {
        title: "Financing, Legal, and Insurance Considerations",
        text: `
        <strong>Mortgage Financing Limitations</strong><br/>
        Most lenders do not provide traditional mortgages for properties on Crown land, 
        especially where the Buyer does not hold title to the land.
        <br/><strong class="bold">Action:</strong> Prepare Buyers for cash purchases or 
        limited lending options through private lenders or lines of credit.
        <br/><br/>
  
        <strong>Title vs. Leasehold Interest</strong><br/>
        The Buyer is not acquiring legal title to the land, but rather a lease or 
        license to use it. These rights may be time-limited or non-renewable.
        <br/><strong class="bold">Action:</strong> Work with legal counsel to ensure the 
        interest is assignable and valid for the intended use.
        <br/><br/>
  
        <strong>Insurance Challenges</strong><br/>
        Insurance for buildings on Crown land may be harder to obtain due to access, 
        remoteness, or unclear land tenure.
        <br/><strong class="bold">Action:</strong> Engage an insurer early and verify 
        property risk factors (e.g., seasonal access, emergency response times).
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the land owned by the Buyer or leased from the Crown?</li>
        <li>What is the term of the lease, and can it be renewed?</li>
        <li>Are there any use restrictions (seasonal vs. full-time use)?</li>
        <li>What is the process for transferring or assigning the lease?</li>
        <li>Are there rules governing improvements, renovations, or new construction?</li>
        <li>Can the property be mortgaged or must it be purchased in cash?</li>
        <li>What services (hydro, water, septic) are available and permitted?</li>
        <li>Is there any risk that the lease will not be renewed or will be revoked?</li>
        <li>Are there environmental protections or conservation restrictions on the property?</li>
        </ol>
        `,
      },
      {
        title: "Common Conditions and Clauses",
        text: `
        <p>
        <strong>Legal Review of Lease or License Agreement</strong><br/>
        Essential due to the unique nature of Crown land transactions.
        <br/><br/>
  
        <strong>Government Approval of Transfer Condition</strong><br/>
        Include a clause stating that the transaction is conditional upon receiving 
        transfer or assignment approval from the Crown (or relevant agency).
        <br/><br/>
  
        <strong>Insurance Condition</strong><br/>
        Confirm that insurability of the structure is feasible prior to closing.
        <br/><br/>
  
        <strong>Financing Clause (if applicable)</strong><br/>
        If financing is being pursued, make it conditional on lender approval of 
        leasehold interest and associated risks.
        <br/><br/>
  
        <strong>Other Potential Clauses</strong>
        <ol>
          <li>Review and approval of lease terms within a set timeframe</li>
          <li>Verification of environmental compliance and approvals</li>
          <li>Confirmation that all improvements were authorized by the Crown</li>
          <li>Disclosure of lease payment schedule and obligations</li>
          <li>Right to terminate if lease is non-transferable or expiring soon</li>
        </ol>
        </p>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "ruralCountry",
    title: "Rural & Country Properties",
    description: `<p>
      Purchasing rural or country property in Ontario often involves systems and considerations
      that differ from urban and suburban homes—private wells and septic systems, larger acreages,
      outbuildings, private/seasonal roads, and proximity to agricultural uses.
      <br/><br/>
      Diligence must extend beyond the dwelling to include land use permissions, access, services,
      and environmental features. Client goals (hobby farm, privacy, hunting, short-term rental,
      future severance, home business, etc.) should be clarified early and revisited as new
      information emerges during showings and investigations.
      <br/><br/>
      Every rural property is unique. REALTORS® should perform thorough due diligence and advocate
      for their clients in line with professional standards. If this is your first rural deal,
      collaborate with an experienced REALTOR® and ensure the client’s lawyer is familiar with rural
      transactions.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those 
        considerations will apply to this scenario as well. 
        Here are some extra things to consider specifically when it comes to 
        country/rural properties.
        <br/><br/>
        <strong>Private Water Wells</strong><br/>
        Identify well type (drilled/dug), location, age, depth, flow rate, and treatment equipment.
        Confirm potable water and review well records if available.
        <br/><strong class="bold">Action:</strong> Include water potability and flow-rate testing in conditions.
        Request recent test results and any service/maintenance records for pumps and treatment systems.
        <br/><br/>
  
        <strong>Septic Systems</strong><br/>
        Determine system type, age, capacity, location of tank and bed, and permit history.
        Look for signs of failure or improper siting near wells or waterways.
        <br/><strong class="bold">Action:</strong> Include a septic inspection/pump-out confirmation.
        Ask for receipts, permits, and as-built diagrams. Ensure access lids are visible and safe.
        <br/><br/>
  
        <strong>Heating, Power & Solid-Fuel Appliances</strong><br/>
        Common heating includes propane, oil, electric, heat pumps, and wood/pellet stoves.
        Verify tank ownership (rental vs owned), age and compliance; check for generators and transfer switches.
        Wood-burning units may require WETT inspections for insurance.
        <br/><strong class="bold">Action:</strong> Confirm fuel contracts/rentals to assume or buy out.
        Include WETT and fuel-tank compliance conditions where applicable.
        <br/><br/>
  
        <strong>Internet, Cell & Utilities</strong><br/>
        Service may be limited. Confirm available internet (fibre, fixed wireless, satellite) and cell coverage.
        Check hydro reliability and known outage frequency.
        <br/><strong class="bold">Action:</strong> Ask Sellers for providers, typical speeds, and any known issues.
        <br/><br/>
  
        <strong>Access: Roads, Driveways & Maintenance</strong><br/>
        Clarify if access is municipal, private, seasonal, or via right-of-way.
        Private/condo roads may require maintenance agreements; seasonal roads may not be plowed.
        <br/><strong class="bold">Action:</strong> Obtain and review any registered access/maintenance agreements.
        Verify winter access and school bus/snow removal routes.
        <br/><br/>
  
        <strong>Boundaries, Surveys & Acreage</strong><br/>
        Fences, old blazes, or tree lines may be inaccurate. Outbuildings, driveways, or fences can encroach.
        <br/><strong class="bold">Action:</strong> Request an up-to-date survey.
        Consider staking/pinning. Verify acreage and usable land (rock, wetland, steep slopes).
        <br/><br/>
  
        <strong>Zoning & Land Use Permissions</strong><br/>
        Rural properties can be zoned Rural, Agricultural, Environmental Protection, etc.
        Uses like livestock, kennels, home industries, secondary units, and short-term rentals vary by municipality.
        Minimum Distance Separation (MDS)from livestock operations can limit new buildings/additions.
        <br/><strong class="bold">Action:</strong> Confirm current and intended uses with the municipality.
        Ask specifically about MDS, home-based businesses, second dwellings, trailers, 
        and STR bylaws, if applicable.
        <br/><br/>
  
        <strong>Conservation Authorities & Setbacks</strong><br/>
        Floodplains, wetlands, shorelines, and hazard lands may restrict development or require permits.
        <br/><strong class="bold">Action:</strong> Check local Conservation Authority mapping and speak with staff
        about any planned changes (garages, additions, driveways, docks).
        <br/><br/>
  
        <strong>Environmental & Natural Features</strong><br/>
        Look for radon potential, abandoned wells, former fuel/oil use, pesticide storage, dumps, or buried debris.
        Woodlots, wetlands, species-at-risk habitat, and watercourses may carry restrictions.
        <br/><strong class="bold">Action:</strong> Ask Sellers about environmental concerns and prior uses.
        Consider specialty inspections or environmental advice if red flags arise.
        <br/><br/>
  
        <strong>Outbuildings & Services</strong><br/>
        Verify permits, electrical safety, and intended uses for barns, shops, and sheds.
        Large shops may trigger zoning/occupancy considerations.
        <br/><strong class="bold">Action:</strong> Confirm hydro subpanels, heating, 
        water lines, and any commercial use, if applicable. Have the appropriate 
        inspections done based on the property.
        <br/><br/>
  
        <strong>Taxes, Programs & HST</strong><br/>
        Property class (residential vs farm) affects taxes. Programs like Managed Forest or Conservation Land Tax
        can reduce taxes but carry obligations. HST may apply to some vacant land, farm assets, or newly built structures.
        <br/><strong class="bold">Action:</strong> Have the client’s lawyer/accountant confirm tax class, program obligations,
        and HST applicability. Reflect HST treatment clearly in the offer.
        <br/><br/>
  
        <strong>Easements, Rights-of-Way & Utilities</strong><br/>
        Confirm hydro/pipeline easements, shared driveways, and any shore road allowances on waterfront parcels.
        <br/><strong class="bold">Action:</strong> Order title search/GeoWarehouse and have the lawyer review for constraints.
        <br/><br/>
  
        <strong>Agricultural Neighbours & Rural Realities</strong><br/>
        Expect noises, odours, dust, equipment traffic, and early/late farm operations protected under normal farm practices.
        <br/><strong class="bold">Action:</strong> Discuss lifestyle fit with clients and visit at different times of day.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Pre-Approval & Lender Comfort</strong><br/>
        Lenders may require water potability, well flow, and septic reports. Private roads/seasonal access,
        large acreages, hobby-farm income, and extensive outbuildings can affect loan-to-value and insurability.
        <br/><strong class="bold">Action:</strong> Engage lenders early and share property specifics up front.
        Line up multiple financing options if the file is non-standard.
        <br/><br/>
  
        <strong>Appraisals in Rural Areas</strong><br/>
        Comparable sales may be scarce; excess acreage and outbuildings may receive limited contributory value.
        <br/><strong class="bold">Action:</strong> Prepare the appraiser with a detailed feature list, recent upgrades,
        and any survey or permits to support value.
        <br/><br/>
  
        <strong>Insurance Considerations</strong><br/>
        Insurers look at distance to fire hall/hydrants, solid-fuel appliances, oil tanks, and age of systems.
        <br/><strong class="bold">Action:</strong> Urge clients to obtain an insurance quote early to confirm coverage and cost.
        <br/><br/>
  
        <strong>Deposits</strong><br/>
        Similar to resale homes in other areas, deposits often range from 5–10% of purchase price, but may vary by market dynamics.
        <br/><strong class="bold">Action:</strong> Set a deposit strategy appropriate to local competition and condition timelines.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>Where are the well and septic located, and what are their ages/capacities?</li>
          <li>What are the most recent water potability and flow results? Who performed them?</li>
          <li>When was the septic last pumped/inspected? Any permits or drawings available?</li>
          <li>Is year-round access maintained? Who plows the road/driveway?</li>
          <li>Which internet/cell providers serve the property, and what speeds are typical?</li>
          <li>Are there conservation authority, floodplain, shoreline, or wetland constraints?</li>
          <li>Are outbuildings permitted and electrically safe? Any commercial use approvals?</li>
          <li>Do zoning and MDS rules permit my intended use (animals, shop, second unit, STRs)?</li>
          <li>Are there easements, rights-of-way, or shared drive/road agreements?</li>
          <li>Any environmental concerns (abandoned wells, old fuel tanks, dumps, radon)?</li>
          <li>Will HST apply to this purchase? Are any tax programs or farm classifications in place?</li>
          <li>Is there an up-to-date survey or evidence of property boundaries?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/> <ol> <li>"Time is of the essence" when it comes to agreements. Make sure that agreements and related deal documents are signed within their designated time frames.</li> <li>Confirm that all BCFSA approved forms and clauses used are both current and appropriate for the specific deal.</li> <li>Check the MLS Listing for any supplemental documents to be included with the offer.</li> <li>Deposit delivery must occur within the specified time frame on the agreement. If the deposit isn't delivered, the client is in breach and may face legal action. </li> <li>Always assign a firm date to conditions and clauses. Phrases like "5 business days" can cause confusion and conflict. A set deadline makes expectations clear for everyone involved.</li> </ol>
        <br/>
  
        <strong>Conditions & Clauses (Rural-Focused)</strong><br/>
        If a client elects to omit a recommended condition, ensure they understand the risks and complete FORM 127.
        It is always best practice to include a Buyer's Lawyer Review condition in the offer, especially if the property 
        has unique characteristics such as wells, septic, private roads, conservation 
        areas, or outbuildings are involved.
        <br/><br/>
        With all the various due diligences that are required for rural properties, 
        consider using a due diligence condition, in addition to the Buyer's Lawyer 
        Review condition:
        <br/><br/>
        <strong>Due Diligence Clause:</strong>
    <br/>
    This Offer is conditional upon the Buyer being able to conduct due diligence for 
    a period of _________ days from the date of acceptance of the Agreement of 
    Purchase and Sale. During this period, the Buyer shall have access to the property 
    for inspections, assessments, and investigations deemed necessary. Unless the 
    Buyer gives notice in writing delivered to the Seller personally or in accordance 
    with any other provisions for the delivery of notice in this Agreement of Purchase 
    and Sale or any Schedule, that this condition is fulfilled, this Offer shall be 
    null and void and the deposit shall be returned to the Buyer in full without 
    deduction. The Seller agrees to co-operate in providing access to the property 
    for the purpose of these investigations. This condition is included for the 
    benefit of the Buyer and may be waived at the Buyer's sole option by notice 
    in writing to the Seller as aforesaid within the time period stated herein.
    <br/> <br/>
        Additional conditions may include the following, as appropriate:
        <ol>
          <li>Any applicable clauses/conditions commonly used in Residential Transactions</li>
          <li>Water potability and well flow-rate testing; delivery of well records and treatment details.</li>
          <li>Septic inspection/pump-out confirmation and evidence of permits/approvals.</li>
          <li>WETT inspection for any solid-fuel appliances and proof of chimney compliance.</li>
          <li>Fuel tank (propane/oil) compliance and transfer of any rental agreements.</li>
          <li>Zoning/Use & MDS verification for intended uses (livestock, shop, second unit, STRs).</li>
          <li>Conservation Authority review for any planned improvements (additions, driveways, docks).</li>
          <li>Survey provision or allowance for staking; title search free of encumbrances affecting use.</li>
          <li>Access & Road Maintenance Agreement review where applicable; confirmation of year-round access.</li>
          <li>HST clause specifying whether HST is included in or in addition to the purchase price.</li>
          <li>Inclusions/exclusions for outbuildings, equipment, and rentals (propane tanks, water heaters, softeners).</li>
        </ol>
        <br/>
        Review the <a href="/ON/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a>
        to match conditions to your client’s goals and the property’s characteristics.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "cooperative",
    title: "Co-operative Residential Homes",
    description: `<p>
      Purchasing in a residential housing co-operative (“co-op”) is different from buying freehold or a condominium.
      Instead of owning real property, Buyers typically purchase shares in a corporation and receive the
      right to occupy a specific unit under an Occupancy Agreement.
      <br/><br/>
      Note that non-profit/community housing co-ops generally do not involve a market purchase or resale;
      they allocate units to approved members and charge housing charges rather than a purchase price. This guide focuses on
      equity or market co-ops where share interests are bought and sold.
      <br/><br/>
      Each co-op sets its own by-laws, membership approval process, rules, and financial practices. REALTORS® should perform
      thorough due diligence, collaborate with an experienced lawyer familiar with co-ops, and align guidance with client goals.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those 
        considerations will apply to this scenario as well. 
        Here are some extra things to consider specifically when it comes to 
        co-operative residential homes.
        <br/><br/>
        <strong>Ownership Structure & Documents</strong><br/>
        Confirm the Buyer is acquiring shares (and any related membership certificate) plus an Occupancy Agreement granting the right to occupy a specific unit.
        Understand how assignments/transfers are handled and any transfer fees.
        <br/><strong class="bold">Action:</strong> Request the full co-op 
        information package, similar to a condo status certificate outlining 
        current budget, reserve/contingency policies, building insurance 
        certificate, by-laws/rules, Occupancy Agreement form, board policies 
        (subletting, pets, renovations, smoking), and recent board minutes.
        <br/><br/>
  
        <strong>Board Approval & Membership</strong><br/>
        Most co-ops require board consent and a membership interview/application (often including references, income/credit checks, and agreement to rules).
        <br/><strong class="bold">Action:</strong> Clarify approval timelines, required documentation, and any non-refundable application/transfer fees. Build these into your condition dates.
        <br/><br/>
  
        <strong>Monthly Fees & What They Cover</strong><br/>
        Charges often include the co-op’s building mortgage payment, property taxes, building insurance, common utilities, maintenance, and reserves; unit-level utilities may be separate.
        <br/><strong class="bold">Action:</strong> Obtain a fee breakdown, history of increases, any scheduled adjustments, and recent/anticipated special assessments.
        <br/><br/>
  
        <strong>Financial Health of the Co-op</strong><br/>
        Similar to a condo, this will typically be done by the lawyer. Review audited statements, debt 
        load (blanket/building mortgage), maturity dates, interest rate exposure, 
        reserve levels, and arrears.
        <br/><strong class="bold">Action:</strong> Ask for the most recent audited 
        financials, current budget, arrears/collections policy, and any 
        engineering/building condition reports.
        <br/><br/>
  
        <strong>Building Condition & Plans</strong><br/>
        Evaluate age/condition of roof, elevators, boilers/HVAC, windows, 
        parking/garage, balconies, and life-safety systems.
        <br/><strong class="bold">Action:</strong> Seek capital plan summaries and 
        recent/ongoing projects. Consider a home inspector for the unit and 
        common-element awareness.
        <br/><br/>
  
        <strong>Use, Renovations & Subletting</strong><br/>
        Co-ops usually restrict rentals and require written consent for sublets 
        and renovations. Some have rules on flooring, pets, BBQs, and smoking.
        <br/><strong class="bold">Action:</strong> Confirm your client’s intended 
        use (e.g., work-from-home, short-term hosting, pets) is permitted. Obtain 
        written policies and any required renovation approval process.
        <br/><br/>
  
        <strong>Title, Encumbrances & Legal Review</strong><br/>
        The corporation owns the real property; members hold shares. Lenders to the 
        co-op may have a blanket mortgage with covenants affecting operations.
        <br/><strong class="bold">Action:</strong> Buyer’s lawyer should review: 
        corporate title, any blanket mortgages/charges, ground lease(s) if 
        land-lease, compliance with by-laws, and whether lenders provide 
        non-disturbance/recognition agreements protecting members’ occupancy rights.
        <br/><br/>
  
        <strong>Insurance</strong><br/>
        The co-op insures the building; members typically insure contents, 
        improvements, and personal liability.
        <br/><strong class="bold">Action:</strong> Obtain the building’s insurance 
        certificate and limits. Have the Buyer secure appropriate unit insurance 
        early; confirm any insurance requirements in the Occupancy Agreement.
        <br/><br/>
  
        <strong>Taxes & HST</strong><br/>
        Property taxes are commonly paid by the corporation (funded via monthly 
        charges). HST/Land Transfer Tax treatment can vary based on structure and 
        circumstances.
        <br/><strong class="bold">Action:</strong> Have the Buyer’s lawyer/accountant confirm tax treatment (including any HST/LTT considerations) and ensure the offer clearly states whether HST is included or in addition, if applicable.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Availability</strong><br/>
        Conventional mortgages on title are not typical for co-ops. Some lenders/credit unions offer share-secured loans or co-op financing products with specific underwriting (board approval, assignment/pledge of shares, recognition agreements).
        <br/><strong class="bold">Action:</strong> Engage knowledgeable lenders early; provide the co-op’s documents up front. Prepare backup options if lender choice is limited.
        <br/><br/>
  
        <strong>Down Payment & Terms</strong><br/>
        Requirements may differ from condo/freehold norms and can vary by lender and co-op policy.
        <br/><strong class="bold">Action:</strong> Confirm minimum down payment, amortization limits, and any lender conditions tied to the co-op’s financials or building mortgage maturity.
        <br/><br/>
  
        <strong>Appraisal Considerations</strong><br/>
        Appraisers may use comparable co-op or condo sales but will account for differences (transferability, financing constraints, fees, building condition).
        <br/><br/>
  
        <strong>Insurance & Lender Security</strong><br/>
        Lenders often require assignment/pledge of shares and a recognition/non-disturbance agreement from the co-op.
        <br/><strong class="bold">Action:</strong> Coordinate early between lender, Buyer’s lawyer, and the co-op to satisfy document and timing requirements.
        <br/><br/>
  
       <strong>Deposit Amount</strong><br/>
      Deposits for resale homes typically range from 5-10% of the purchase price and held in the 
      Buyer Brokerage's trust account.
      <br/><strong class="bold">Action:</strong> Discuss a deposit strategy with your 
      client, factoring in local market competitiveness.<br/>
      
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>What is the board’s approval process, timeline, and criteria?</li>
          <li>What do monthly housing charges include, and what increases are anticipated?</li>
          <li>Are there any planned special assessments or major capital projects?</li>
          <li>What is the status of the co-op’s building mortgage (rate, maturity, covenants)?</li>
          <li>Are there arrears issues among members, and how are they handled?</li>
          <li>What are the policies on pets, smoking, subletting, and renovations?</li>
          <li>Is parking/storage included or assigned, and how are allocations managed?</li>
          <li>Are there transfer fees, right-of-first-refusal provisions, or waiting lists?</li>
          <li>What insurance coverage does the co-op carry, and what must the member carry?</li>
          <li>Are there any legal disputes or regulatory compliance issues disclosed?</li>
          <li>How does the co-op handle accessibility upgrades and accommodation requests?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/> <ol> <li>"Time is of the essence" when it comes to agreements. Make sure that agreements and related deal documents are signed within their designated time frames.</li> <li>Confirm that all BCFSA approved forms and clauses used are both current and appropriate for the specific deal.</li> <li>Check the MLS Listing for any supplemental documents to be included with the offer.</li> <li>Deposit delivery must occur within the specified time frame on the agreement. If the deposit isn't delivered, the client is in breach and may face legal action. </li> <li>Always assign a firm date to conditions and clauses. Phrases like "5 business days" can cause confusion and conflict. A set deadline makes expectations clear for everyone involved.</li> </ol>
        <br/>
  
        <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/ON/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "foreclosures",
    title: "Foreclosures",
    description: `<p>
      A foreclosure in British Columbia occurs when a lender seeks to recover a debt after a borrower defaults, 
      through a legal process governed by the <em>Court Order Enforcement Act</em>. 
      Unlike Power of Sale procedures used in some other provinces, foreclosure in BC is a 
      court-supervised process where the lender must obtain approval from the BC Supreme Court 
      before selling or taking title to the property.  
      The property is typically sold under a court order, and the lender or its lawyer makes 
      very limited or no representations and warranties regarding the home’s condition.  
      Most foreclosure properties are sold strictly “as is, where is,” with the sale terms 
      set out in the court-approved order and the lender's Schedule or Addendum.
      <br/><br/>
      These transactions require extra diligence around title, possession, condition, insurance, and timing. Client goals (primary residence, flip, rental, land value) should be clarified early and revisited as new information emerges. Always involve a lawyer experienced with foreclosure sales.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Judicial Foreclosure Overview</strong><br/>
        Foreclosures in BC are a court-supervised process where the lender must 
        obtain approval from the BC Supreme Court before selling or taking title 
        to the property.  
        The property is typically sold under a court order, and the lender or its 
        lawyer makes very limited or no representations and warranties regarding 
        the property's condition.  
        Most foreclosure properties are sold strictly “as is, where is,” with the 
        sale terms set out in the court-approved order and the lender's Schedule or 
        Addendum.
        <br/><strong class="bold">Action:</strong> Review the lender's Schedule carefully before 
        drafting the offer. Highlight clauses dealing with property condition, utilities, 
        possession, and hold-harmless terms. Ensure clients understand that repairs, inclusions, 
        and appliances are not guaranteed.
        <br/><br/>
      
        <strong>Right of Redemption</strong><br/>
        Until a court issues a final order approving the sale, the original borrower (mortgagor) 
        retains the right to redeem the mortgage by paying off the debt in full.
        <br/><strong class="bold">Action:</strong> Advise Buyers that the sale may be delayed or 
        cancelled if the borrower redeems before court approval. Ensure timelines and deposit 
        handling accommodate this risk.
        <br/><br/>
      
        <strong>Property Condition & Access</strong><br/>
        Foreclosed homes are often vacant, neglected, or winterized, and the lender rarely 
        authorizes repairs or reactivation of utilities.
        <br/><strong class="bold">Action:</strong> Arrange for a qualified home inspection when 
        possible. Confirm in writing whether power, gas, or water can be activated for testing, 
        and who bears responsibility for any costs or damages during reactivation.
        <br/><br/>
      
        <strong>Occupancy, Tenancies & Possession</strong><br/>
        Some foreclosed properties remain occupied by the former owner or tenants. 
        The lender usually does not guarantee vacant possession unless specified by the court.
        <br/><strong class="bold">Action:</strong> Verify occupancy status. If possession by 
        completion is essential, ensure the offer and court order address this specifically. 
        Discuss timelines and potential eviction procedures with the client’s lawyer.
        <br/><br/>
      
        <strong>Title, Arrears & Encumbrances</strong><br/>
        Title is conveyed by the lender’s lawyer under a court order. Most financial charges 
        are discharged on completion, but other encumbrances such as easements, rights-of-way, 
        and covenants remain.
        <br/><strong class="bold">Action:</strong> Order a title search from the 
        Land Title and Survey Authority (LTSA). 
        Review for unpaid property taxes, strata liens, or judgments. Confirm with the lawyer 
        how adjustments or discharges will be handled. Recommend title insurance for added protection.
        <br/><br/>
      
        <strong>Strata Properties</strong><br/>
        Lenders generally will not obtain a current Form B (Information Certificate) or Form F 
        (Certificate of Payment) for strata properties.
        <br/><strong class="bold">Action:</strong> Make your offer conditional on the Buyer 
        obtaining and reviewing these forms directly from the strata management company. Review 
        arrears, bylaws, and contingency fund details before subject removal.
        <br/><br/>
      
        <strong>Environmental & Safety Considerations</strong><br/>
        Foreclosure properties can carry risks such as water damage, mold, fuel tanks, or past 
        illegal activity.
        <br/><strong class="bold">Action:</strong> Consider specialized inspections such as 
        environmental testing, WETT inspections, sewer scope, or air quality testing depending 
        on the property’s age and condition.
        <br/><br/>
      
        <strong>Insurance Challenges</strong><br/>
        Vacant or distressed properties can be difficult to insure or may require specialized 
        coverage.
        <br/><strong class="bold">Action:</strong> Encourage clients to obtain an insurance quote 
        early and disclose that the property is a foreclosure. Confirm the insurer’s vacancy and 
        inspection requirements before completion.
        <br/><br/>
      
        <strong>Court Process, Timing & Competing Offers</strong><br/>
        After the lender accepts an offer, it is submitted to court for approval. At the court 
        hearing, other Buyers may attend and submit competing bids in open court. The judge 
        selects the final accepted offer and confirms it by court order.
        <br/><strong class="bold">Action:</strong> Prepare clients for the uncertainty of the 
        process. Once the court approves the sale, completion typically occurs within 14–30 days. 
        Explain that the Buyer must attend (or have representation at) the hearing if they wish 
        to adjust their offer should competing bids arise.
        <br/><br/>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Constraints</strong><br/>
        Most lenders will only finance foreclosure properties in “as is” condition. 
        Significant defects, unfinished spaces, or disconnected utilities may make the 
        home ineligible for standard mortgage programs.
        <br/><strong class="bold">Action:</strong> Engage a mortgage broker experienced 
        in foreclosure purchases. Disclose the property’s condition and status early, 
        and explore backup financing options such as private or alternative lending 
        if needed.
        <br/><br/>
      
        <strong>Appraisal Access & Valuation</strong><br/>
        Because properties are sold “as is” and court access can be restricted, 
        appraisers may have limited ability to assess the home’s true value.
        <br/><strong class="bold">Action:</strong> Coordinate appraisal access promptly 
        with the listing REALTOR® or lender’s lawyer. Provide inspection reports and 
        photographs to assist with valuation.
        <br/><br/>
      
        <strong>Deposit & Trust Handling</strong><br/>
        Deposits are typically required in certified funds (often 5–10% of the purchase price) 
        and held in the Buyer's Brokerage's or Lawyer's trust account until court approval.
        <br/><strong class="bold">Action:</strong> Confirm deposit instructions and timelines 
        in advance. Ensure compliance with BCFSA 
        trust account regulations, and advise clients that deposits may be held longer due 
        to court scheduling.
        <br/><br/>
      
        <strong>Insurance & Completion Preparation</strong><br/>
        Buyers must arrange insurance immediately after court approval, as coverage may be 
        required for completion and mortgage funding.
        <br/><strong class="bold">Action:</strong> Confirm that the insurer and lender accept 
        the property’s condition and vacancy status. Plan for a compressed timeline between 
        court order and closing.
        <br/><br/>
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
  <li>Will the lender or court guarantee vacant possession? (Usually no — confirm in writing if vacant possession is ordered by the court.)</li>
  <li>Can utilities be turned on for inspection or appraisal? Who assumes liability if damage occurs during activation?</li>
  <li>What does the lender’s Schedule or Addendum modify compared to the standard BC Contract of Purchase and Sale?</li>
  <li>Are there unpaid property taxes, strata fees, or registered liens that will remain or be cleared on completion?</li>
  <li>What are the insurance implications of the property’s vacant or distressed condition?</li>
  <li>If it’s a strata property, who obtains and pays for the Form B (Information Certificate) and Form F (Certificate of Payment)?</li>
  <li>Can the lender or court extend the closing date? Under what circumstances would this occur?</li>
  <li>Are there any outstanding municipal work orders, building permits, or zoning compliance issues?</li>
  <li>If the property is occupied, what are the expected timelines and procedures for obtaining vacant possession after completion?</li>
  <li>Has the borrower’s right of redemption expired, or could the foreclosure still be delayed or cancelled before court approval?</li>
</ol>

        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
       <strong>Offer Best Practices</strong><br/>
        <ol>
        <li>Ensure all contracts are completed using the latest forms.</li>
        <li>“Time is of the essence” applies—ensure all deadlines are met and deposits delivered on time.</li>
        <li>Check for any documents or disclosures attached to the listing.</li>
        <li>All deposit funds must comply with brokerage trust requirements under RESA.</li>
        <li>Always assign firm dates to conditions (avoid vague terms like “five business days”).</li>
        </ol>
  
        <br/>
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is 
        important to ensure they understand the risks and are comfortable with the 
        potential consequences. Furthermore, ensure you complete the Buyer's 
        Acknowledgement of Advice, Rights and Benefits Form for situations where 
        your clients choose to not include a recommended condition in the offer.        <br/><br/>
        The Home Buyer Rescission Period (HBRP) does not apply on court sales.
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        
      `,
      },
    ],
  },
  /*ADDITIONAL TOPICS*/
  {
    type: "transaction topic",
    id: "commission",
    title: "Commission Related Practices",
    description: `<p>
    Ensure you are using the correct form for Commission Agreements:
      <a
                    href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Commission Agreement Form
                  </a>
                  <br />
      <br/>
     </p>`,
    text: [
      {
        title: "How to Ask for a Commission Increase as a Buyer Agent",
        text: `
        <strong>Step 1: </strong> <strong class="bold">The Buyer MUST provide authorization to the REALTOR® in a 
        separate written document BEFORE the preparation of the offer.</strong><br/>
        Suggested wording is as follows:<br/><br/>
        If the compensation being offered by a listing brokerage or a Seller to the 
        Buyers Brokerage is less than _____________________ then the Buyers Brokerage 
        is hereby authorized to modify the offered amount of compensation in the terms 
        of the CPS and or negotiate prior to submitting offer.<br/><br/>
        <strong>Step 2: </strong> <strong class="bold">Advise the Listing Broker that 
        you will be requesting a modification.</strong><br/>
        There are 2 methods to achieve this:<br/><br/>
        <strong>Method 1: Add as a Subject</strong>.<br/>
        This offer is subject to the Buyers Brokerage ________________ receiving 
        irrevocable written confirmation on or before __________( typically 12 hours 
        or less ) from both the Seller and the Listing Brokerage that the amount of 
        commission that the said Buyer”s Agent will receive from the Listing 
        Brokerage on completion will be ______________plus applicable gst. This 
        condition is for the sole benefit of the Seller.<br/><br/>
        <strong>Method 2: Talk to the Listing Agent</strong>.<br/>
        <strong class="bold">Talk to the Listing Agent and have the commission agreed 
        upon prior to submitting the offer.</strong><br/>
        Sometimes Sellers will agree to a higher commission prior to the offer. If so, 
        have them complete and sign the commission agreement form before you submit 
        the offer.<br/><br/>
        `,
      },
      {
        title: "Getting Paid with Exclusive Listings",
        text: `
        Have the listing agent and the Seller complete and sign the Commission 
        Agreement form before you submit the offer.
        <br/><br/>
      `,
      },
      {
        title: "How to Reduce Commission (Listing Side)",
        text: `
        <strong>CANNOT Be a part of the Contract & the REALTOR® must sign</strong><br/>
        <strong class="bold">A new Disclosure of Sellers Expected Remuneration is to be 
        done if the change was after a FIRM deal.</strong><br/><br/>
        <strong>Method 1: Listing Amendment</strong><br/>
        <strong class="bold">Use this method if it is a permanent change.</strong><br/>
        <ol>
        <li>Use a listing amendment form to change the commission</li>
        <li>Listing Amendment should note the new Gross, List Side, Buy Side 
        commission amount or percentage</li>
        <li>Submit to the board if the cooperating brokerage commission is changed</li>
       </ol> 
        <br/>
        <strong>Method 2: Addendum</strong><br/>
        <strong class="bold">Use this method if you are adjusting the commission for 
        one particular deal.</strong><br/><br/>
        Sample Clause:<br/>
        eXp Realty and I agree to reduce the commission on the sale of your property 
        by _____________________(including GST), if the contract noted above between 
        Seller(s)___________ and Buyer(s)______________ becomes a firm and binding 
        contract.
        `,
      },
      {
        title: "How to Reduce Commission (Buyer Side)",
        text: `
        <strong>CANNOT Be a part of the Contract & the REALTOR® must sign</strong><br/>
        Create a document that is separate from the Contract (example: letter or 
        separate addendum page 1 of 1) signed by the Seller, Listing Agent, and 
        Buyer Agent.<br/><br/>
        <strong class="bold">Buyer Agent commission reduction, Buyer gets credit:</strong><br/><br/>
        eXp Realty and __________________ agree to reduce their commission from $ __________ including GST to $ _______________________ including GST. Seller agrees to give the Buyer a credit on the statement of adjustments of $______________________.
        <br/><br/>
        <strong class="bold">Buyer Agent commission reduction:</strong><br/><br/>
        eXp Realty and __________________ agree to reduce their commission from $ __________ including GST to $ _______________________ including GST.<br/><br/>
        <strong class="bold">Buyer Agent paid full commission - rebate to client </strong><br/>
        No additional document needed. If Buyer wants something in writing the Buyer Agent 
        can sign a document stating the rebate amount.<br/><br/>
        <strong class="bold">eXp will NOT write a cheque to the client, you will need 
        to rebate your client directly after completion.</strong><br/><br/>
        `,
      },
      {
        title: "Listing not on MLS",
        text: `
        <strong>Depends on 2 things (All forms on WebForms):</strong><br/>
        <ol>
        <li>Who you represent</li>
        <li>Who is paying you</li>
        </ol>
        <strong class="bold">To negotiate more commission when the Sellers are 
        represented:</strong><br/><br/>
        <strong>Exclusive Listings Contract:</strong><br/>
        Fee Agreement Buyer Pays (Seller Represented Buyer Not)<br/><br/>
        <strong>When Seller is Unrepresented:</strong><br/>
        Fee Agreement Seller Pays (Buyer Represented Seller Not)<br/> OR<br/>
        Buyers Agency Exclusive Contract<br/><br/>
      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "landAssembly",
    title: "Land Assembly",
    description: `<p>
   <strong>Ensure you educate Yourself and the Sellers</strong><br/>
     Explain to clients that the timeframe differs from a regular purchase and sale. By 
     the time the home is completed, it could be a year or more later.<br/><br/>
     So, yes, they may sell for more today as part of an assembly, but they must keep 
     in mind that the market may be different at completion and they need to have 
     realistic expectations.
     <br/><br/>
     For example, if the market moves upward, they may not be able to afford the type 
     of property they expected to purchase today.<br/><br/>
     <strong>Important: </strong>Co-List with another REALTOR® if you have not done 
     this type of transaction before.
     </p>`,
    text: [
      {
        title: "Language you Need to Understand",
        text: `
        <strong>Official Community Plan (OCP): </strong> <br/>
        <strong class="bold">Community Plan </strong>= a general plan with city-wide 
        framework for local areas.<br/>
        The Official Community Plan (OCP) designates the general land uses for the 
        entire city—broad categories such as Residential, Industrial, Commercial, and 
        Agricultural. Within these broad land use designations, several specific land 
        uses are permitted. For example, the Residential designation allows for a wide 
        range of residential lot types and sizes, as well as multi-family development.
        <br/><br/>
        <strong>Neighbourhood Concept Plan (NCP):</strong><br/>
        <strong class="bold">Neighbourhood Plan (aka Secondary Plan, Area Plan, 
        Local Plan) </strong>= specific local area matters/issues.<br/>
        These plans designate allowable land uses and development patterns in much 
        greater detail and apply only to certain parts of a city. In different 
        municipalities, they are referred to by various names, such as Neighbourhood 
        Concept Plan, Neighbourhood Plan, Area Plan, or Secondary Plan.<br/>
        The OCP covers the entire municipality, whereas NCPs cover only parts of the 
        municipality.
        <br/><br/>
        <strong>Zoning Bylaw:</strong><br/>
        <strong class="bold">Rezoning </strong>change the zoning bylaw, permits 
        different uses, permits different densities, etc.<br/>
        These regulations state the permitted uses, minimum lot sizes, and other standards with precise definitions. There are many different zone types for specific land uses, and each municipality has its own set of zones and terminology.
        <br/>
        Changes to municipal plans are possible and are typically facilitated through discussions with municipal staff. This may include amendments to an OCP or NCP land use designation, or a rezoning application. A rezoning can be to another existing standard zone or to a CD (Comprehensive Development) zone, which is custom-written for the proposed site development.
        <br/><br/>
        <strong>Subdivision Bylaw:</strong><br/>
        These provisions allow for the creation of lots with minimum sizes and dimensions. They can be used to create two or more properties, consolidate properties, or adjust an existing lot line.
        <br/><br/>
        <strong>UPA/FAR/FSR:</strong><br/>
        <strong class="bold">UPA </strong>= Units per Acre (example: residential houses)<br/>
        <strong class="bold">FAR </strong>= Floor Area Ratio (example: commercial, apartments)<br/>
        <strong class="bold">FSR </strong>= Footage Space Ratio 
        <br/><br/>
        <strong>Other Miscellaneous Terms:</strong><br/>
        <strong class="bold">Development Permits (DP): </strong> form and character of buildings.
        <br/><strong class="bold">Building Permit (BP): </strong> approval that allows construction.
        <br/><strong class="bold">Greenfield: </strong> new development on raw land.
        <br/><strong class="bold">Intensification / Urban Infill: </strong> redevelopment of existing areas.
        <br/><strong class="bold">Special Districts: </strong> areas such as downtowns, corridors, transportation hubs, airports, etc.
        <br/><strong class="bold">Different Development Focuses: </strong> retail, office, employment, residential, and institutional uses.
        <br/><strong class="bold">Transit-Oriented Development (TOD): </strong> maximizes residential units, jobs, and amenities within walking distance of transit.
        <br/><br/>
        <strong>Coversion References:</strong><br/>
        <strong class="bold">1 metre: </strong> 3.28 ft
        <br/><strong class="bold">1 ft: </strong> 0.3048 metres
        <br/><strong class="bold">1 m²: </strong> 10.7639 sq ft
        <br/><strong class="bold">1 sq ft: </strong> 0.0929 sq metre
        <br/><strong class="bold">10,000 sq metres: </strong> 1 hectare
        <br/><strong class="bold">43,560 sq ft: </strong> 1 acre
        <br/><strong class="bold">1 hectare: </strong> 2.47105 acres
        <br/><strong class="bold">1 acre: </strong> 0.404686 hectares
        `,
      },
      {
        title: "Calcluating Density - Site Area",
        text: `
        <strong>What is the site area and density?</strong><br><br>

There is the gross area, which includes the entire site boundary before any development; the site area net of any non-developable areas, such as environmentally sensitive lands that may substantially impact the site; and the site area net of all non-developable areas and road dedication requirements.<br><br>

<ul>
  <li><strong>Gross Area:</strong> total site</li>
  <li><strong>Neighbourhood Area:</strong> including all development uses</li>
  <li><strong>Net Developable Area:</strong> excluding non-developable areas</li>
  <li><strong>Net Area:</strong> also excluding road dedications</li>
</ul><br>

Be sure to understand what people mean when they refer to density and site area. Calculate the allowable density according to the definitions of density and site area in the zoning bylaw.<br><br>

Also, be careful not to confuse acre and hectare units. To convert from hectares to acres, multiply by 2.47; to convert from acres to hectares, multiply by 0.404.<br><br>

<ul>
  <li><strong>Gross Density:</strong> includes all lands (roads, parks, community uses)</li>
  <li><strong>Net Density:</strong> remaining subdivided parcels of land (lots)</li>
</ul>

      `,
      },
      {
        title: "Calculating Density - Units",
        text: `
        <strong>Density Ratio:</strong> the amount of use (number of units) divided by the amount of area (acres or hectares of land).<br><br>

<strong>Measures of Density:</strong>
<ol>
  <li>Number of units – housing, jobs, residents, etc.</li>
  <li>Units per Acre (upa) / Units per Hectare (uph)</li>
  <li>Example: houses per acre of land</li>
</ol><br>

Housing forms range from low to high density, approximately 1 upa to 100 upa.<br><br>

The more valuable the land, the more intensively it is generally used. However, density is not the only consideration. Design and access/linkages are also important to allow transportation of goods and people between destinations.<br><br>

<strong>Calculating Density (Square Feet):</strong><br>
Density ratio = amount of use (sq ft of building) divided by the amount of area (sq ft of land).<br><br>

<strong>Measures of Density in Sq Ft:</strong>
<ol>
  <li>Calculating density using sq ft</li>
  <li>Density ratio = amount of use (sq ft of building) ÷ amount of area (sq ft of land)</li>
  <li>Different measures depending on type of use</li>
</ol>
        `,
      },
      {
        title: "Videos on Land Assembly",
        text: `
        <a href="https://www.youtube.com/watch?v=1rJao27fA58" target="_blank" 
        rel="noopener noreferrer">
        Let's Talk Land Assembly - Part 1
        </a>
        <br/><br/>
        <a href="https://www.youtube.com/watch?v=-Hq9CbFc2es" target="_blank" 
        rel="noopener noreferrer">
        Let's Talk Land Assembly - Part 2
        </a>
        <br/><br/>
        <a href="https://www.youtube.com/watch?v=fdqU34quxcc" target="_blank" 
        rel="noopener noreferrer">
        Agency in Assembly (Start at 30:23)
        </a>
        <br/><br/>
        `,
      },
      {
        title: "Additional Resources",
        text: `
       <strong>Planning / Real Estate / Industry Associations:</strong>
<ol>
  <li><a href="https://www.pibc.bc.ca" target="_blank" rel="noopener noreferrer">Planning Institute of British Columbia (PIBC)</a></li>
  <li><a href="https://www.cip-icu.ca" target="_blank" rel="noopener noreferrer">Canadian Institute of Planners (CIP)</a></li>
  <li><a href="https://www.aibc.ca" target="_blank" rel="noopener noreferrer">Architectural Institute of British Columbia (AIBC)</a></li>
  <li><a href="https://www.aicanada.ca" target="_blank" rel="noopener noreferrer">Appraisal Institute of Canada (AACI)</a></li>
  <li><a href="https://www.apeg.bc.ca" target="_blank" rel="noopener noreferrer">Association of Professional Engineers BC</a></li>
  <li><a href="https://www.planning.org" target="_blank" rel="noopener noreferrer">American Planning Association (APA)</a></li>
  <li><a href="http://britishcolumbia.uli.org" target="_blank" rel="noopener noreferrer">Urban Land Institute (ULI) BC</a></li>
  <li><a href="http://udi.bc.ca" target="_blank" rel="noopener noreferrer">Urban Development Institute (UDI) Vancouver</a></li>
  <li><a href="https://www.naiopvcr.com" target="_blank" rel="noopener noreferrer">NAIOP Vancouver – Industrial and Office Developers</a></li>
  <li><a href="https://havan.ca" target="_blank" rel="noopener noreferrer">HAVAN – Home Builders Association of Vancouver</a></li>
  <li><a href="https://www.reibc.org" target="_blank" rel="noopener noreferrer">Real Estate Institute of British Columbia</a></li>
  <li><a href="https://www.civicinfo.bc.ca" target="_blank" rel="noopener noreferrer">Civic Info BC</a></li>
</ol><br/>

<strong>Mapping and Property Data:</strong>
<ol>
  <li><a href="http://www.tetrad.com/maps_and_data/canada/streetmaps" target="_blank" rel="noopener noreferrer">Tetrad Canada Streets Map</a></li>
  <li><a href="https://www.precisely.com/about-us/pitney-bowes-software-and-data" target="_blank" rel="noopener noreferrer">Pitney Bowes / Precisely</a></li>
  <li><a href="https://datasolutions.altusgroup.com" target="_blank" rel="noopener noreferrer">Altus Data Solutions</a></li>
  <li><a href="https://www.costar.com" target="_blank" rel="noopener noreferrer">CoStar</a></li>
  <li><a href="https://www.autoprop.ca" target="_blank" rel="noopener noreferrer">AutoProp</a></li>
  <li><a href="https://zondaurban.com" target="_blank" rel="noopener noreferrer">Zonda / Urban Analytics</a></li>
  <li><a href="https://www.landcor.com" target="_blank" rel="noopener noreferrer">Landcor Data Corporation</a></li>
  <li><a href="https://www.greensheet.ca" target="_blank" rel="noopener noreferrer">Green Sheet Construction Data</a></li>
  <li><a href="https://www.metrovancouver.org/business/gis" target="_blank" rel="noopener noreferrer">Metro Vancouver GIS</a></li>
</ol><br/>

<strong>Sold / Comparable Data Available At:</strong>
<ol>
  <li>MLS</li>
  <li><a href="https://www.commercialedge.com/" target="_blank" rel="noopener noreferrer">Commercial Edge</a></li>
  <li>Real Map</li>
  <li>Auto Edge</li>
  <li>Connection – main source, with developers, contacts, etc.</li>
</ol>
      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "inspection",
    title: "Inspections",
    description: `<p>
    <strong>Remember that Inspectors will not find ALL deficiencies!</strong><br/><br/>
    <ol>
  <li><strong class="bold">Educate your clients </strong>about what happens during an inspection and the type of outcome to expect (they will <strong class="bold">always</strong> find something).</li>
  <li><strong class="bold">Understand what your clients care about most </strong>and inform the inspector to take extra effort in checking it.  
      <ul>
        <li>Example: If a client is allergic to mold, inform the inspector.</li>
      </ul>
  </li>
  <li><strong class="bold">Do not give advice </strong>on inspection results or the cost of repairs.   
      <ul>
        <li>These should come from the inspector and other professionals in the relevant fields.</li>
        <li>You don’t want to tell your client it will cost $500, only for it to end up being $1,000.</li>
      </ul>
  </li>
  <li><strong class="bold">Strata Properties:</strong>  
      <ul>
        <li>Some buildings will allow inspection of common areas, but most will not, as they typically have depreciation reports.</li>
        <li>If the building allows common area inspection, make sure you inform the listing agent to schedule it.</li>
      </ul>
  </li>
</ol>
     </p>`,
    text: [
      {
        title: "During the Inspection",
        text: `
        <strong>Purpose: </strong>
To provide key information about the home to allow the Buyer(s) to make an informed decision on their purchase.<br><br>

<strong>Focus: </strong>
Major defects or repairs that may cost the Buyer to remedy after purchasing the home.<br><br>

<strong>Inspection Covers: </strong>
A complete visual examination of the home from top to bottom.<br><br>

<strong>The Inspector commonly reports on their visual inspection regarding the condition of: </strong>

<ol>
  <li>Structure</li>
  <li>Roof (type, age, condition)</li>
  <li>Foundation</li>
  <li>Drainage</li>
  <li>Plumbing</li>
  <li>Heating & Cooling System</li>
  <li>Electrical (copper, knob & tub, aluminum)</li>
  <li>Visible Insulation</li>
  <li>Walls</li>
  <li>Windows & Doors</li>
  <li>Fireplaces (if wood burning, recommend a WETT inspection)</li>
  <li>Drywall (1994 or older - possible Asbestos)</li>
  <li>Appliances</li>
</ol><br>

<strong>How Long Does It Take?</strong><br>
<ol>
  <li>Typically 2–3 hours for a House</li>
  <li>Typically 1–1½ hours for a Condo</li>
</ol>
`,
      },
      {
        title: "After the Inspection",
        text: `
        <strong>What happens if the Home Inspector makes a discovery?</strong><br/>
        Obtain a copy of the inspection and review. Make sure to have the Inspector 
        explain the report not you. <br/><br/>


       <strong>Plan Your Strategy:</strong>
<ol>
  <li>Plan your conversation with your Buyers.</li>
  <li>Plan your strategy with the Seller's representative, based on direction provided by your Buyers.</li>
  <li>Determine your goal. What are your clients looking to achieve? For example, a price reduction or possibly corrective measures.</li>
  <li>Prioritize the issues. Identify the most important priorities for your client and note less important concerns.</li>
  <li>Empathize with the Seller. Plan a collaborative outcome to achieve desired results for a win-win solution.</li>
  <li>Stay flexible. Understand what a realistic outcome looks like and know what your clients are truly wanting, including which issues they are willing to “release.”</li>
  <li>Be willing to walk away. Know your clients' expectations and when they are prepared to walk away from the deal.</li>
  <li>Ask for a price concession. Understand how to request concessions effectively. Grouping the items together, rather than breaking them down individually, can help achieve greater results.</li>
  <li>Get as much information as possible. Gather information on why your clients want what they are asking for.</li>
  <li>Be informed on the items and the corrective measures that need to be taken. Speak with an expert in the relevant field regarding client concerns and obtain documentation to substantiate the request.</li>
</ol>


      `,
      },
      {
        title: "Clauses to Consider",
        text: `
        <strong>Deficiency List After Inspection</strong><br/>
        The Seller, at the Seller’s Expense, will complete and/or repair the items specified below or on the attached deficiency list and valued at $___________________________. The list forms a part of this contract. The quality of work and materials used will be equal to or better than that of the surrounding construction.<br/><br/>
        The Buyer will hold back from the sale proceeds the amount specified above until all the deficiencies specified in the deficiency list are completed, and will place this hold-back in the conveyancer’s trust account. In the event that all the deficiencies are not corrected within 15 days of completion, the Seller authorizes the Buyer’s conveyancer to release the balance of the holdback to the Buyer.<br/><br/>
        Seller agrees to repair/replace the deficiencies at least ____ days before completion and will allow the Buyer access to the property at least _____ days before completion to ensure the deficiencies have been corrected.<br/><br/>
        Any dispute concerning completion of deficiencies and release of the hold-back will be settled by arbitration under the Commercial Arbitration Act of B.C..<br/><br/>
        All other terms and conditions in the said Contract of Purchase and Sale remain the same and in full force and effect.<br/>
        1)<br/>
        2)<br/>
        3)<br/>
        4)<br/>
        <br/><br/>
        <strong>Seller Gives Buyer Credit on Statement of Adjustments</strong><br/>
        Seller agrees to give the Buyer a credit on the statement of adjustments of
$ ________________________ for the following items found during the inspection: __________________________________________.<br><br/>
ALL OTHER TERMS AND CONDITIONS IN THE SAID AGREEMENT REMAIN THE SAME AND IN FULL FORCE AND EFFECT.
 <br/><br/>
 <strong>Seller Reduces Price Due to Defect(s)</strong><br/>
        Buyer and Seller agree to reduce the purchase price to ____________________________ for the following items found during the inspection: ______________________________________________.<br><br/>
ALL OTHER TERMS AND CONDITIONS IN THE SAID AGREEMENT REMAIN THE SAME AND IN FULL FORCE AND EFFECT.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "poa",
    title: "Power of Attorneys & Corporate Clients",
    description: `<p>
    
     </p>`,
    text: [
      {
        title: "Power of Attorney (POA)",
        text: `
        <strong>Documents Needed:</strong><br/>
        <ol>
        <li>Copy of Valid POA Document</li>
        <li>FINTRAC - 3rd Party: A 3rd party is someone who is signing or acting on behalf of someone else or is being influenced by another person. For example, if someone is signing using a Power of Attorney (POA), they are considered a 3rd party.</li>
        </ol><br/>
        <strong>Important Notes:</strong><br/>
        <strong class="bold">POA Document:</strong><br/>
        <ol>
        <li>Make sure you check the document</li>
        <li>How many POA(s) need to sign for the person</li>
        <li>Has the POA expired or is it still valid?</li>
        <li>Does the POA doc give the POA the autority for the purpose of Buying 
        or Selling a property? (POAs can be for specific purposes)</li>
        </ol>
        <br/>
        <strong class="bold">POA needs to sign for each person they represent: </strong>
        If the POA represents 2 Sellers, they will need to sign twice (once for 
        each Seller)<br/><br/>
        <strong class="bold">The names on the contract should match the clients' names as they appear on the title.</strong>
        <br/><br/>
        <strong class="bold">Make sure to write “Name POA For Name” next to all signatures (not required for initials).</strong><br/>
        Example: John Apple, Power of Attorney for Marie Unabletosign
          <br/><br/>
       `,
      },
      {
        title: "Corporate Clients",
        text: `
        <strong>Documents Needed:</strong><br/>
        <ol>
        <li>Corporate FINTRAC</li>
        <li>Annual Corporate Filings</li>
        <li>Notice of Articles (or document that shows directors). If there is more 
        than 1 director and not all are signing, you need to obtain a document showing 
        who can sign or a resolution of the company stating who can sign</li>
        <li>FINTRAC Invididual ID for all directors that are signing the documents</li>
        <li>Business Summary (can be ordered on bconline)</li>
        </ol><br/>
        <strong>Important Notes:</strong><br/>
        <ol>
        <li>Search to make sure the company is active</li>
        <li>If the Seller is a company, GST may be applicable</li>
        <li>The name on the Contract = Company Name. Person signing, signs 
        with their own name</li>
        </ol>
       `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "oilTanks",
    title: "Oil Tanks",
    description: `<p>
    <strong>Important Notes:</strong><br/>
   
<ol>
  <li>Always include an oil tank clause for homes built before 1970.</li>
  <li>If an oil tank is discovered later, all previous Sellers may be responsible for the removal costs.</li>
  <li>Removing a clean, empty, non-contaminated oil tank typically costs a few thousand dollars.</li>
  <li>Oil tank removal becomes more expensive with larger contamination.<br/>  
  For example, if the house is on a slope, oil can travel more easily, increasing cleanup costs.
  </li>
</ol>

<p>Licensees involved in the listing or sale of a property that contains, or may contain, an underground or above-ground heating oil storage tank (OST) should be aware that the presence of an OST can, due to potential environmental concerns, expose both Sellers and Buyers to significant financial loss and liability. If the presence of an OST is known or suspected, Buyers and Sellers should be advised to consult an environmental professional, as well as seek legal advice regarding their obligations and potential liabilities.<br/><br/>
Many homes built before 1970 were heated using oil stored in underground or above-ground OSTs. When these homes were later converted to natural gas or electricity, underground tanks were often not removed; instead, they were typically left in place, filled with sand, and capped. OSTs that remain buried may have rusted or corroded over time. If any oil remained in the tank, leaking could cause—or may have already caused—contamination of the property and neighboring properties.
</p>
     </p>`,
    text: [
      {
        title: "Seller has Oil Tank Certificate Clause",
        text: `
        Subject to the Seller providing the Buyer with a copy of a oil tank inspection report and or a oil tank removal certificate on or before ___________. This is for the sole benefit of the Buyer`,
      },
      {
        title: "Not sure if there is an Oil Tank - Clause",
        text: `
        <strong class="bold">If the existence of an oil tank is unknown, the Buyer typically pays for the inspection, and the Seller is responsible for the removal costs.</strong>        <br/><br/>
        Subject to the Buyers, in the Buyers’ sole and absolute discretion, on or before _____________reviewing and approving a Geoscan ground-penetrating radar report [see Oil Tank clause below] related to investigations into the presence or absence of an underground oil storage tank. This condition is for the sole benefit of the Buyer.<br/><br/>
        The Seller agrees, at the Seller’s expense, to commission Geoscan to conduct ground-penetrating radar investigation of the property to confirm the presence or absence of an underground oil tank. Geoscan Report to be provided to the Buyers on or before —_______________.<br/><br/>
        It is hereby acknowledged that this is a FUNDAMENTAL TERM OF THIS THIS AGREEMENT: In the event, an underground oil storage tank is found on the Property, and the Buyers waive or declare fulfilled or remove the “Oil Tank Subject Clause” mentioned above, the Sellers agree and covenant to have the underground oil storage tank removed at their expense, and to bear the costs of any associated contamination. The Seller will provide the Buyer with certification of work having been completed in accordance with the rules and regulations of the {INSERT MUNICIPALITY] prior to Completion Date.<br/><br/>
        In the event that the required work cannot be finished prior to the Completion Date, the Seller agrees that an amount equal to the quoted costs of removal and a reasonable expectation of contamination from a qualified oil tank removal service will be held back from the proceeds of sale until the work has been completed and all required certificates of approved removal have been provided to the Buyer. The Seller agrees to provide access to the property with reasonable notice to conduct an oil tank scan including ground-penetrating radar if needed. Should anything need to be moved in order to conduct the scan, the Seller also agrees to clear any items to ensure the scan is accurate.
      `,
      },
      {
        title: "Representing Seller - What to do",
        text: `
        <strong>If a Seller is Aware of an OST:</strong><br>
The Seller has an obligation to disclose an unused or abandoned OST when it constitutes a material latent defect.<br>
While an unused or abandoned OST may not necessarily be considered a material latent defect in all circumstances, it is clear that a court would likely find an OST to be a material latent defect if actual leakage could be shown to have occurred.<br>
Any representation about an OST on a disclosure statement made by the Seller must be accurate, and a licensee acting for the Seller must not participate in a representation that they know to be incorrect.<br>
A Seller may need to consult environmental and legal professionals to determine whether the tank in question constitutes a material latent defect.<br><br>

<strong>If a Seller is Not Aware of an OST:</strong><br>
When a Seller is not aware of an unused or abandoned OST, but the licensee has reason to believe one may be present on the property, there is a possibility that an OST, if found, could be considered a material latent defect.<br>
Courts have held that a licensee acting for a Seller has a duty “to check the completeness and accuracy of all information which it is usual and customary for brokers to verify.”<br>
Accordingly, it may be prudent for a licensee to advise the Seller to take the necessary steps to determine whether an OST is present, so that the later discovery of a tank—either before completion or after the sale—does not leave the Seller exposed to significant potential liabilities and expenses.<br>


        `,
      },
      {
        title: "Representing Buyer - What to do",
        text: `
       <strong>If a Licensee Representing a Buyer is Aware of an OST:</strong><br>
If a licensee representing a Buyer knows that a property contains an unused or abandoned OST, the licensee has a duty to inform the Buyer-client of this fact.<br>
The licensee must also advise that the presence of an OST, due to potential environmental concerns, exposes the Buyer to significant financial loss and liability.<br><br>

<strong>If a Licensee Suspects the Presence of an OST:</strong><br>
If a licensee acting for a Buyer is not aware of an unused or abandoned OST, but suspects—or reasonably ought to suspect—its presence based on factors such as the age of the property, then section 3-3(1)(h) of the Council Rules requires the licensee to use reasonable efforts to determine whether an OST is present.<br>
If the licensee’s own efforts do not resolve the question, section 3-3(1)(d) of the Council Rules requires the licensee to advise the Buyer-client to seek any necessary professional advice, such as from an environmental engineer or consultant, and possibly legal advice as well.<br>

      `,
      },
      {
        title: "OST Does Exist - What to do",
        text: `
       <strong>OST Awareness and Regulations:</strong><br>
Where it has been determined that an OST exists, licensees and their clients should be aware of BC Fire Code provisions for the decommissioning of an underground OST. These provisions require the use of good engineering practices when removing, abandoning in place, or temporarily taking an underground OST out of service.<br><br>

Licensees should also refer their clients to the BC Ministry of Environment Fact Sheet entitled <em>Residential Heating Oil Storage Tanks</em>, which provides concise and valuable information and advice. This Fact Sheet, along with other useful information and links, can be found on the Ministry of Environment’s website: 
<a href="http://www.env.gov.bc.ca" target="_blank" rel="noopener noreferrer">
www.env.gov.bc.ca
</a>.<br><br>

Further, licensees must ensure that they or their clients inquire at their local government office (city, municipal, district, or regional) regarding any bylaws, restrictions, or permit requirements concerning unused or abandoned OSTs. Local governments have differing requirements and enforcement provisions for the removal or abandonment of underground or above-ground OSTs, usually administered by the local fire department. This is particularly important in areas where enforcement of storage tank removal is a priority.<br><br>

Lending institutions and insurers should also be consulted, as they may have corporate policies regarding underground or above-ground OSTs.<br><br>

When drafting contracts for properties containing underground or above-ground OSTs, licensees should familiarize themselves with the information in the <em>Safety, Health and Environmental Disclosure Clauses</em> section of the Professional Standards Manual. This resource is available online at: 
<a href="https://www.bcfsa.ca/industry-resources/real-estate-professional-resources/knowledge-base/clauses/clauses?hits=health,safety,environmental" target="_blank" rel="noopener noreferrer">
https://www.bcfsa.ca/industry-resources/real-estate-professional-resources/knowledge-base/clauses/clauses?hits=health,safety,environmental
</a>.<br><br>

Licensees with questions can contact the BCFSA office at 604-683-9664, toll-free 1-877-683-9664, or via email at <a href="mailto:info@bcfsa.ca">info@bcfsa.ca</a>.<br>

      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "multipleOffers",
    title: "Multiple & Referential Offers",
    description: `<p>
     </p>`,
    text: [
      {
        title: "Listing Side",
        text: `
       <ol>
  <li>MUST disclose to all parties as soon as a deal becomes a multiple offer</li>
  <li>Use the Webform “Disclosure of Multiple Offers Presented” and present it to your Seller at the time of presenting offers</li>
  <li>The agent then sends this form to every agent or unrepresented party one day after the offer is accepted or rejected</li>
  <li>If the date or time of an offer is changed, update it on MLS and inform all interested parties</li>
  <li>MUST keep copies of all offers and upload them to SkySlope</li>
  <li>Create a folder in SkySlope and upload all unaccepted offers into this folder</li>
  <li>It is recommended that the Seller cross out, write “rejected,” and sign page 1 of the contract as proof that it was presented to the Seller</li>
  <li>There is no need to disclose how many offers exist; only that it is a multiple offer situation</li>
  <li>If you are writing an offer for an unrepresented Buyer and are cutting your commission (not recommended), this MUST be disclosed to all parties</li>
  <li>Schedule offer presentations from Tuesday to Friday so Buyers have time to complete inspections or obtain mortgage approval</li>
  <li>You cannot counter more than one offer at a time</li>
  <li>If you are dealing with a referential offer, see below for instructions</li>
</ol>

        `,
      },
      {
        title: "Buyer Side",
        text: `
       <ol>
  <li>If your client is proceeding subject-free, make sure you explain everything to them and have them sign the waiver of subjects.</li>
  <li>Educate your client that, in most cases, they will only have one opportunity to proceed.</li>
  <li>Include a reminder in the contract that the Seller will allow access to bank appraisers or other necessary parties. Even though the offer is subject-free, the Buyer’s bank will still require access to the property.</li>
</ol>
      `,
      },
      {
        title: "Direction Regarding Presentation of Offers",
        text: `
    <ol>
  <li>Educate your Sellers about the potential for “bully offers”</li>
  <li><strong>Bully Offers:</strong> A Buyer agent sends an offer via email while knowing the offer presentation is scheduled for a later date. The offer is usually strong, which may tempt the Seller to change the offer presentation time</li>
  <li>Once an offer is signed, it must be uploaded to MLS and disclosed in the REALTOR® Remarks</li>
  <li>If you have a delayed offer advertised, you MUST sign a DRPO</li>
  <li>The Seller has the right to change their mind about when to accept offers; however, as an agent, this requires the following steps:
    <ol>
      <li>Sign an updated Directions form</li>
      <li>Upload the new form to MLS and update the REALTOR® Remarks</li>
      <li>Inform all parties who have requested notification of the new date and time for the offer presentation. Any missed parties may have a valid complaint against you, not your Seller</li>
      <li>Ensure all interested Buyers are given sufficient time to submit an offer</li>
    </ol>
  </li>
  <li>If you are the Buyer’s agent, make sure to put in writing to the listing agent that you want to be notified of offer updates</li>
  <li>If you were planning to view the home during an open house, message the listing agent to keep you informed of any bully offers</li>
</ol>
      `,
      },
      {
        title: "Referential Offer - What you need to know",
        text: `
   <ol>
  <li>We recommend NOT accepting referential offers and advise the buyers that the seller will NOT consider any referential offers</li>
  <li>To make a referential offer fully enforceable, a counter is required with an actual price which the buyer may choose to reject</li>
  <li>It is safer to sign an offer than to have to counter</li>
  <li>MUST include a “max price”; it cannot be just an amount higher than the highest offer</li>
  <li>When receiving a referential offer, best practice is for the seller to counter at the stated price to avoid a non-enforceable contract</li>
  <li>If you receive more than one referential offer, the seller still has the right to choose which one to work with. Remember to counter back with an actual price</li>
  <li>Sample clause: “The purchase price is $1,000 above the price offered in the nearest competing bona fide offer acceptable to the seller to a maximum price of $350,000. The seller agrees to provide a copy of such nearest competing offer on acceptance of this offer”</li>
</ol>
<br/>
<strong>Detailed Info on Referential Offers from BCFSA:</strong><br/>

 In an environment of multiple offers, a listing agent might receive an offer 
 containing what is generally referred to as a "referential purchase price clause" 
 (RPPC). The RPPC allows a buyer to establish a purchase price by referencing prices 
 in competing offers. The purpose of the RPPC is for a buyer to piggyback on the next 
 highest bona fide offer acceptable to the seller. 
 <br/><br/>Such a clause might read as follows:
<br/><em>The purchase price is $1,000 above the price offered in the nearest competing bona fide offer acceptable to the seller to a maximum price of $350,000. The seller agrees to provide a copy of such nearest competing offer on acceptance of this offer.</em><br/>
 <br/>
  <ol>
  <li>A referential offer is an offer that does not stand on its own and is not understandable without reference to another bid. The House of Lords held that referential offers are invalid</li>
  <li>An offer by one bidder that depends on the offers of others is invalid and unacceptable, as it is inconsistent with and potentially destructive to the tendering process in which it is submitted</li>
    </ol><br/>
  To avoid potential problems, a listing agent should consider the following guidelines when confronted with an RPPC clause:
    <ol>
      <li>Review the referential offer with the seller carefully, as it might not be the best offer regarding other terms besides price, such as the buyer's financial qualifications, dates, and subject-to clauses</li>
      <li>If the offer appears to be the best, advise the seller to counter it by deleting the RPPC clause and inserting a fixed price for the same amount</li>
      <li>This counter-offer should be open to the buyer who presented the referential offer for acceptance before the expiration of any other offer the seller may be considering</li>
      <li>If the buyer accepts the seller’s counter-offer, it is no longer a referential offer, as it becomes a contract for a fixed price</li>
      <li>If the buyer refuses the seller’s counter-offer while it is open for acceptance, the seller is free to counter or accept another offer as long as it has not expired</li>
      <li>If acting as a limited dual agent for both the buyer presenting a referential offer and the seller, the licensee must ensure both parties understand the limitations of dual agency</li>
  
  </li>
</ol>
      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "radon",
    title: "Radon Gas",
    description: `<p>
    <strong>Important Notes:</strong><br/>
<ol>
  <li>Radon is an invisible radioactive gas produced by the breakdown of uranium in the ground</li>
  <li>Radon is found in every home in Canada and is the #1 cause of lung cancer for non-smokers</li>
  <li>Testing is the only way to determine if a home has dangerous levels of radon</li>
  <li>In some cases, real estate professionals use a holdback to allow for radon testing after a transaction is complete</li>
  <li>If a high radon level is found in the home, mitigation can be completed using the holdback funds</li>
  <li>Brand-new homes must have radon gas air exchange systems built in</li>
  <li><a href="https://www.reca.ca/wp-content/uploads/2019/06/Radon-Checklist-Residential-Real-Estate-Seller.pdf" target="_blank" rel="noopener noreferrer">Checklist for Sellers</a></li>
  <li><a href="https://www.reca.ca/wp-content/uploads/2019/06/Radon-Checklist-Residential-Real-Estate-Buyer.pdf" target="_blank" rel="noopener noreferrer">Checklist for Buyers</a></li>
  </ol>

     </p>`,
    text: [
      {
        title: "Should I Get My Home Tested?",
        text: `
       <strong>Radon Testing Recommendations:</strong>
<ol>
  <li>Everyone is encouraged to test their home for radon</li>
  <li>Radon levels vary widely from house to house, even in the same neighborhood, because concentrations depend on factors such as the geology of the area, housing construction, and characteristics like air exchange in the home</li>
  <li>In general, radon concentrations tend to be highest in the lowest levels of a building, including basements</li>
  <li>The only way to be absolutely sure of the radon concentration in a home is to test</li>
  <li>Those living in Interior and Northern communities in B.C. are especially encouraged to test their homes for radon</li>
</ol>

        `,
      },
      {
        title: "How Do I Get My Home Tested?",
        text: `
        <strong>Radon Testing Overview:</strong>
<ol>
  <li>Radon testing is easy, relatively inexpensive, and can be done with do-it-yourself tests. A long-term radon detector is placed in the lowest level of your home that is occupied for more than 4 hours per day</li>
  <li>Specific instructions are provided with the detector. Once the test is completed, ideally over a period of 3 months to 1 year including some winter months, the detector is mailed to a lab for analysis</li>
  <li>The lab provides the testing results as an average radon concentration over the test period. This level can be compared to Health Canada’s guideline of 200 Bq/m³</li>
  <li>Because no level of radon is considered without harm, individuals are encouraged to consider remediation even if levels are close to or below the guideline</li>
  <li>The cost of a testing device and results is approximately $30 to $50</li>
  <li><strong>Long-term radon testing:</strong> If only one test is done, it should be a three to twelve month long-term test. Radon levels vary over time, so a long-term test provides the most accurate picture of actual average exposure levels and should be used to determine if mitigation is required</li>
  <li><strong>Short-term radon testing:</strong> An initial short-term test can be helpful for those eager to find out if a potential radon problem exists. Common situations include real estate transactions, building inspections, health facilities, commercial workspaces, after new home construction, and for homeowners living in regions where radon levels are known to be elevated</li>
  <li>It is recommended that a short-term radon test always be followed by a long-term radon test</li>
</ol>

      `,
      },
      {
        title: "Where Can I Get A Radon Testing Device?",
        text: `
      <strong>Radon Testing Suppliers and Resources:</strong>
<ol>
  <li>For a list of suppliers of radon testing devices, visit the <a href="https://www.bccdc.ca/resource-gallery/Documents/Guidelines%20and%20Forms/Guidelines%20and%20Manuals/EH/RPS/Radon%20Testing%20in%20Cda.pdf" target="_blank" rel="noopener noreferrer">BC Centre for Disease Control</a> (PDF 247 KB) or look under ‘home inspection services’ in your local phone listings</li>
  <li>Test kits are also available from:
    <ol>
      <li>BC Lung Association RadonAware – Purchase a radon test kit <a href="https://thelungassociationbc.squarespace.com/" target="_blank" rel="noopener noreferrer">here</a>, call 1-800-665-5864</li>
      <li>Northern Health Authority – Call 250-565-2150, toll-free 1-800-663-7867, or email <a href="mailto:radon@northernhealth.ca">radon@northernhealth.ca</a></li>
      <li><a href="https://www.takeactiononradon.ca/" target="_blank" rel="noopener noreferrer">www.takeactiononradon.ca</a></li>
      <li>Donna Schmidt Memorial Lung Cancer Prevention Society – Call 250-365-0344 ext 227 or email <a href="mailto:dschmidt@golder.com">dschmidt@golder.com</a>. Note: Kits are limited to locations in the Kootenays</li>
    </ol>
  </li>
  <li>You can also hire a certified radon measurement professional to test your home. Health Canada recognizes the Canadian National Radon Proficiency Program. For more information see <a href="https://c-nrpp.ca/" target="_blank" rel="noopener noreferrer">https://c-nrpp.ca</a></li>
</ol>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "foreclosuresTopic",
    title: "Foreclosures",
    description: `<p>
     </p>`,
    text: [
      {
        title: "What Is A Foreclosure?",
        text: `
        <strong>Steps of a Foreclosure:</strong>
<ol>
  <li>Bank hires a law firm to manage the foreclosure</li>
  <li>Lawyer hires a REALTOR® on behalf of the bank (lawyer usually receives a referral % from the commission)</li>
  <li>Lawyer works with the REALTOR® to decide on pricing</li>
  <li>The REALTOR® will be asked to fill out forms every time a price change is requested</li>
</ol><br/>

<strong>Foreclosure on the MLS:</strong>
<ol>
  <li>Like any listing, the foreclosure is posted on MLS</li>
  <li>Any buyers submitting an offer while it is on MLS can include any subjects they wish</li>
  <li>Reminder: The contract cannot include the seller promising anything beyond what is allowed</li>
  <li>Once the buyer subjects are removed, the deal becomes firm subject to court approval</li>
  <li>The court will set a date for others to come and “bid” on the property</li>
  <li>On the day of the court sale, any offers submitted must be subject-free with a deposit</li>
  <li>The highest price will get the home, and a previous buyer can bid again in court</li>
</ol><br/>

<strong>Foreclosure Court Info:</strong>
<ol>
  <li>View the daily court list at <a href="https://justice.gov.bc.ca/cso/courtLists.do" target="_blank" rel="noopener noreferrer">https://justice.gov.bc.ca/cso/courtLists.do</a></li>
  <li>Look up a file number (not free) at <a href="https://justice.gov.bc.ca/cso/esearch/esearchHome.do" target="_blank" rel="noopener noreferrer">https://justice.gov.bc.ca/cso/esearch/esearchHome.do</a></li>
</ol>
`,
      },
      {
        title: "Listing Side - What To Do",
        text: `
       <strong>Key Points:</strong>
<ol>
  <li>Seller on the listing contract is the bank listed on the court order</li>
  <li>Do NOT need to FINTRAC the seller, who in this case is the bank</li>
  <li>Communicate with the representative from the lawyer’s firm</li>
  <li>Ask the buyer’s agent for a longer acceptance time, as banks might take longer to sign</li>
  <li>Make sure to arrive early on the court date to communicate with the lawyer</li>
  <li>If the home is under 10 years old – Owner Builder Home</li>
  <li>Normally the owner would apply to HPO for the required documents, but if the property is being foreclosed on, the REALTOR® will have to apply</li>
  <li>REALTOR® needs to email HPO at <a href="mailto:licensinginfo@bchousing.org">licensinginfo@bchousing.org</a> and attach the following:
    <ol>
      <li>Court order document</li>
      <li>Identify who the new owner is (“the client”)</li>
      <li>Address of the property</li>
      <li>Email requesting an owner builder disclosure</li>
    </ol>
  </li>
</ol>
      `,
      },
      {
        title: "Buying Side - What To Do",
        text: `
        
<ol>
  <li>Contract cannot have the seller promising anything</li>
  <li>Buyer name on the contract MUST be 100% correct and cannot change or add a buyer after court approval</li>
  <li>Deposit MUST equal or be greater than 5% of the purchase price</li>
  <li>Schedule A must form part of the contract</li>
  <li>Buyer must acknowledge the property is being sold as is, where is</li>
  <li>Even if appliances are seen on the viewing date, they may not be present on possession</li>
  <li>As is, where is means the condition at possession is what the buyer receives, not what they saw on the viewing date</li>
  </ol>
  <br/><strong>Main differences between putting in an offer before court and at court:</strong><br/>
    <ol>
      <li>At court, the offer submitted MUST be subject-free</li>
      <li>No changes or corrections to the contract</li>
      <li>One-shot deal; no back and forth with price</li>
      <li>Must bring a copy of the deposit</li>
    </ol>
        `,
      },
      {
        title: "What Is Needed On The Contract?",
        text: `
       <strong>Contract MUST Haves:</strong>
<ol>
  <li>Subject must include: Subject to Court Approval. Attached Schedule “A” forms part of the contract</li>
      <li>Completion date = X business days after court approval</li>
      <li>Possession/Adjustment date = 1 day after completion</li>
      <li>#7: Cross out and add Included items: “Sold as is, where is” but excluding: “All Chattels – non-fixtures”</li>
      <li>Clause #8 Viewed – cross out whole clause and initial</li>
   
 </ol><br/>
  <strong>Subjects (only allowed prior to court):</strong>
    <ol>
      <li>If you have a subject to inspection – remove “Seller will allow access”</li>
      <li>If you have a subject to strata documents – remove “Seller will provide”</li>
      <li>Anything requiring the seller to provide or promise something MUST be removed</li>
    </ol>

      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "gst",
    title: "GST",
    description: `<p>
    <strong>Please have your client seek independent legal and/or accounting advice if GST is or may be applicable. Do not provide advice, as you are not an expert.</strong><br/>
    <br/>
    <strong>Contract MUST Address GST:</strong>
<ol>
  <li>Contract must specify whether GST applies or not</li>
  <li>Cannot include “Seller will pay if applicable”</li>
  <li>If the seller provides a certificate stating GST is not applicable, but it is later found to be applicable, the buyer has some protection under Section 194 of the ETA</li>
  <li>Unless explicitly noted, a GST-taxable sale price is considered “GST-extra” pricing, meaning that GST must be added to the agreed purchase price</li>
  </ol><br/>
   <p> <strong>GST Rebate:</strong></p>
  <ol>
  <li>Potential rebate of 36% for owner-occupied or rental properties</li>
  <li>Only available for homes under $350,000; partial rebate for homes priced $350,000 to $450,000</li>
  <li>Must be filed within two years after the end of the month in which the tax first becomes payable</li>
  <li><a href="https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/gst-hst-businesses/gst-hst-rebates/new-housing-rebate.html" target="_blank" rel="noopener noreferrer">Gov't GST Rebate Information</a></li>

  </ol>
     </p>`,
    text: [
      {
        title: "When Is GST Generally Applicable?",
        text: `
       <strong>Please have the client seek legal and/or accountant advice</strong>
<ol>
  <li>Never-lived-in homes, including resale of never-lived-in presales and new builds</li>
  <li>Substantially renovated homes (down to the studs)</li>
  <li>Strata hotels</li>
  <li>Short-term rental properties</li>
  <li>Mixed-use properties (treat as separate properties for GST purposes; GST partially applicable)
    <ol>
      <li>Example: ½ residential use, ½ commercial use</li>
      <li>Example: daycare operating out of a home</li>
    </ol>
  </li>
  <li>Assignment of presales – Contract 5.18 states “assignment amount is inclusive of any GST and Assignor responsible to remit”</li>
  <li>More info on:
    <ol>
      <li><a href="https://drive.google.com/file/d/1QcCiWmpUj5lbjHxD4ir8zfPkuoG9LSyT/view" target="_blank" rel="noopener noreferrer">Used Residential Homes</a></li>
      <li><a href="https://drive.google.com/file/d/1_nkbcQLasptHEsEDayG-EPqFl-NLbWnZ/view" target="_blank" rel="noopener noreferrer">New Construction</a></li>
      <li><a href="https://drive.google.com/file/d/1N-QGe0KtiUDfH_zDUGKwpyiIw5euIUEY/view" target="_blank" rel="noopener noreferrer">Land Only / Farm Land</a></li>
    </ol>
  </li>
</ol>
`,
      },
      {
        title: "When GST MIGHT Be Applicable",
        text: `
       <strong>Please have the client seek legal and/or accountant advice</strong>
<ol>
 
  <li>Farmland, which may be partially subject to GST or GST exempt</li>
  <li>Vacant land, for example if subdivided into three or more parcels</li>
  <li>If the land was for personal use or subdivided into fewer than three parcels, it may be GST exempt</li>
  <li>Seller is a corporation</li>
  <li>Resort properties and vacation homes</li>
  <li>Purchase of a house that is torn down and resold as land only</li>
  <li>Sale of a house for relocation to a new lot, unless it remains under the same lot number</li>
</ol>

      `,
      },
      {
        title: "Bare Land Considerations",
        text: `
        <strong class="bold">GST treatment for bare land varies depending on the Seller:</strong>
<ol>
  <li>If sold by a corporation or partnership, bare land is always subject to GST</li>
  <li>If sold by a non-profit entity, the land is usually GST exempt</li>
  <li>If personal-use land is sold by an individual or trust, it is generally GST exempt</li>
</ol>
        `,
      },
      {
        title: "GST Clauses",
        text: `
       
        <strong>BCFSA GST Clauses:</strong><br/>
        Refer to the <a href="https://www.bcfsa.ca/industry-resources/real-estate-professional-resources/knowledge-base/clauses/clauses#gst" target="_blank" rel="noopener noreferrer">BCFSA GST Clauses</a> for detailed examples of common clauses.
        <br/><br/>
        <strong>Seller Warrants No GST:</strong><br/>
        Seller warrants that GST is not applicable. In the event GST is payable on the purchase of the property, the GST is included in the Purchase Price. The Seller agrees to remit GST to the CRA. The Seller will indemnify and save harmless the Buyer for the payment of GST.
        <br/><br/>
        <strong>Purchase Price PLUS GST:</strong><br/>
        On page 1 of the Contract - write next to price “Plus GST”<br/><br/>
        On a separate page write “GST is applicable price does not include GST”    
          
`,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "taxes",
    title: "Tax Resources",
    description: `<p>
    <strong>Visit the following resources for more information on taxes:</strong><br/>
        <br/><a href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/about-your-tax-return/tax-return/completing-a-tax-return/personal-income/line-12700-capital-gains/principal-residence-other-real-estate.html" target="_blank" rel="noopener noreferrer">Captial Gains Tax</a>
        <br/><br/><a href="https://www2.gov.bc.ca/gov/content/taxes/property-taxes/property-transfer-tax/additional-property-transfer-tax" target="_blank" rel="noopener noreferrer">Foreigners Tax</a>
        <br/><br/><a href="https://vancouver.ca/home-property-development/empty-homes-tax.aspx" target="_blank" rel="noopener noreferrer">Empty Home Tax - Vancouver ONLY</a>
        <br/><br/><a href="https://www2.gov.bc.ca/gov/content/taxes/speculation-vacancy-tax" target="_blank" rel="noopener noreferrer">Speculation and Vacancy Tax - in areas of BC</a>
        <br/><br/><a href="https://www.canada.ca/en/revenue-agency/services/tax/international-non-residents/individuals-leaving-entering-canada-non-residents/non-residents-canada.html" target="_blank" rel="noopener noreferrer">Non-Residents of Canada</a>
     </p>`,
    text: [
      {
        title: "Property Transfer Tax in BC",
        text: `
       
       <strong>Property Transfer Tax Rates:</strong>
<ol>
  <li>1% of the fair market value up to and including $200,000</li>
  <li>2% of the fair market value greater than $200,000 and up to and including $2,000,000</li>
  <li>3% of the fair market value greater than $2,000,000</li>
  <li>An additional 2% on residential property over $3,000,000</li>
  </ol>
  <a href="https://submit.digital.gov.bc.ca/app/form/submit?f=a0cc2fd5-b029-433d-95a9-224d1c2a99ce" target="_blank" rel="noopener noreferrer">Click here to access the calculator</a><br/><br/>
  
  <strong>Types of Exemptions: </strong>
  <a href="https://www2.gov.bc.ca/gov/content/taxes/property-taxes/property-transfer-tax/exemptions" target="_blank" rel="noopener noreferrer">Click here for more information</a>

   
          
`,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "newconstruction",
    title: "New Construction",
    description: `<p>
    <strong>Contract Must Mention the Following:</strong>
<ol>
  <li>GST – clearly address who pays GST, noting that the party paying GST is normally the party entitled to the rebate</li>
  <li>Builder liens holdback</li>
  <li>Copy of warranties</li>
  <li>Copies of occupancy certificates</li>
  <li>Standard development disclosure statements when a developer is selling five or more units</li>
  <li>Duplex properties</li>
</ol>

     </p>`,
    text: [
      {
        title: "Useful Resources",
        text: `
        <a href="https://www.bcfsa.ca/industry-resources/real-estate-developer-resources/real-estate-development-marketing-act-faqs?hits=real,estate,development,marketing,act" target="_blank" rel="noopener noreferrer">REDMA (Real Estate Development Marketing Act)</a>
        <br/><br/><a href="https://newhomesregistry.bchousing.org/" target="_blank" rel="noopener noreferrer">Home Warranty @ BC Housing</a>
        <br/><br/><a href="https://www.bclaws.gov.bc.ca/civix/document/id/complete/statreg/11_29_99a" target="_blank" rel="noopener noreferrer">Homeowner Protection Act Regulation</a>
        <br/><br/><a href="https://www.bchousing.org/licensing-consumer-services/owner-builder/how-to-become-owner-builder" target="_blank" rel="noopener noreferrer">Owner Builder FAQ</a>
        <br/><br/><a href="https://drive.google.com/file/d/1j3iKq6sEPySXtOm2_kzbRwxo9OGBwnDX/view" target="_blank" rel="noopener noreferrer">New Construction Walk Through Checklist Guide</a>
        <br/><br/><a href="https://www.saanich.ca/assets/Local~Government/Documents/Inspections/Regulatory-Bulletin-06-Substantially-Reconstructed-Homes.pdf" target="_blank" rel="noopener noreferrer">Substantially Reconstructed Homes</a>
`,
      },
      {
        title: "Types of New Construction",
        text: `
        <strong>Build To Suit</strong><br/>
        <ol>
  <li>Add a subject to the buyer and seller entering into a separate building contract by __________________. This subject is for the sole benefit of the buyer</li>
  <li>REALTORS® assist with selling the land, while the builder and the buyer should negotiate and enter into a separate agreement for the construction portion</li>
</ol>
        <br/>
        <strong>Substantially Completed</strong><br/>
        These are typically homes that buyers can walk into and view, and it is usually too late to make flooring or finish selections<br/>
        <ol>
      <li>Complete both a home inspection and a walkthrough</li>
      <li>MUST include a builder lien holdback clause</li>
      <li>MUST clearly list all deficiencies, meaning work that still needs to be completed</li>
      <li>MUST check the New Home Registry</li>
    </ol>
      `,
      },
      {
        title: "Acting for Seller - What You Need To Know",
        text: `
        <strong>BC Housing and Owner-Builder Requirements:</strong>

  Check <a href="https://lims.bchousing.org/LIMSPortal/registry/Newhomes/" target="_blank" rel="noopener noreferrer">BC Housing</a> to confirm the home is registered and eligible for sale.
  <br/><br/>If the seller is an owner-builder:<br/>
    <ol>
      <li>MUST live in the home for at least one year. Permission to sell may be granted in cases of hardship. The owner-builder can download an application form from the Licensing and Consumer Services branch of the BC Housing website</li>
      <li>Required to provide an Owner-Builder Disclosure Notice, obtained from the Licensing and Consumer Services branch of BC Housing, to prospective purchasers within the first 10 years after occupancy</li>
      <li>The owner-builder must advise the Licensing and Consumer Services branch of BC Housing of the occupancy date. The Disclosure Notice is not released until the one-year occupancy requirement has been verified</li>
      <li>Subsequent purchasers are also required to provide the Disclosure Notice if they sell the home within the 10-year period</li>
    </ol>
  <br/>When a licensee represents a seller who is an owner-builder, or a subsequent owner within the first 10 years as required by the HPA Regulations, the licensee should insert a clause in the Contract of Purchase and Sale confirming delivery of the Owner-Builder Disclosure Notice<br/>
  <br/><strong>Receipt of Owner-Builder Disclosure Notice Clause:</strong><br/>
  The Buyer acknowledges having received a copy of the Owner-Builder Disclosure Notice dated (date), prior to making this offer, in accordance with the Homeowner Protection Act and regulations

        `,
      },
      {
        title: "Acting for Buyer - What You Need To Know",
        text: `
        <strong>Steps for Purchasing a New Home:</strong>
<ol>
  <li>Step 1: Write up the contract with all new home subjects and terms, and clearly state whether GST is included in the purchase price or in addition to it</li>
  <li>Step 2: Have an inspector complete a home inspection, as even brand-new homes may have issues</li>
  <li>Step 3: Schedule a walkthrough and determine what the developer needs to complete. This can be done at the same time as the inspection</li>
  <li>Step 4: Create a deficiency list outlining what the seller needs to fix, change, or complete</li>
  <li>Step 5: Set a date to return and confirm that all agreed-upon items have been completed</li>
</ol>

      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "probate",
    title: "Probate Estate Sales",
    description: `<p>
    The main question to ask is whether Probate has been completed.
      <br/><br/>
     </p>`,
    text: [
      {
        title: "Listing Side - Probate Completed",
        text: `
        <strong>If probate is complete and title shows the new name, the only 
        differences from a regular listing are:</strong><br/>
        <ol>
  <li>The name on the listing contract must match the name shown on title</li>
  <li>The seller name should be listed as the executor of the estate, as shown on title</li>
  <li>Example: John Doe, Executor of the Estate of Jane Doe</li>
  <li>The individual name shown on title signs the contract</li>
  <li>A copy of the grant or certificate of probate is required</li>
  <li>FINTRAC the executor as an individual, not as a third party</li>
</ol><br/>
<strong>If probate is complete but the title has not yet been updated:</strong><br/>
<ol>
  <li>Sometimes probate has been completed but title has not yet been updated, ask the lawyer for documents confirming probate is complete</li>
  <li>Example of proper execution on behalf of an estate: “G. Seller, Executor or Administrator of the Estate of the deceased”</li>
</ol>

`,
      },
      {
        title: "Listing Side - Probate Not Completed",
        text: `
        <ol>
  <li>On the listing contract, the seller is listed as “Estate of John Doe”</li>
  <li>Signed by the executor of the estate</li>
  <li>Next to the signatures, indicate “Executor of the Estate” (not required for initials)</li>
  <li>Provide a document showing who the executors are that can sign, e.g., the will</li>
  <li>If there is more than one executor, the document will state who must sign and whether all executors need to sign</li>
  <li>In REALTOR® remarks, remind the other agent that the sale is subject to probate</li>
  <li>There is no exact timeline for probate; it could take over 3 months</li>
  <li>If probate is completed during the listing, updates must be made</li>
  <li>Submit a listing amendment to change the seller’s name</li>
  <li>Provide a copy of the probate</li>
</ol>

      `,
      },
      {
        title: "Buying Side - Probate Completed",
        text: `
          If probate is completed, the only differences from a regular sale are as follows:

        <ol>
  <li>Name of the seller must be shown as “Name of Executor of the Estate of Name”</li>
  <li>All other aspects of the transaction are the same as a regular sale</li>
</ol>


        `,
      },
      {
        title: "Buying Side - Probate Not Completed",
        text: `
       
        <strong>Probate can take a long time to complete:</strong><br/>
        <ol>
  
  <li>It is recommended to set the completion date as “X business days after probate” instead of a specific date to avoid multiple changes</li>
  <li>If the buyer has an earliest date they can complete by, add “the later of _____ or X business days after probate”</li>
  </ol><br/>
  <strong>Add the following clause to the contract:</strong><br/>
   
    “Subject to the Seller receiving the following by _______________: (1) a copy of a grant of probate or letters of administration which allow the Property to be sold; and (2) assurance that everyone entitled to claim under the Wills, Estates and Succession Act has waived or released their claims against the Property. This condition is for the sole benefit of the Seller.”
  
      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "tenants",
    title: "Tenants - What You Need To Know",
    description: `<p>
    <ol>
  <li>After a lease (fixed-term tenancy) ends, the tenancy automatically becomes month to month, regardless of what was agreed upon</li>
  <li>At the end of a fixed-term tenancy or during a month-to-month tenancy, a tenant can only be evicted for a valid reason, such as seller or buyer own use</li>
  <li>A common mistake is believing a tenant can be evicted at the end of a lease without cause; a valid reason is required, and the tenancy website should be consulted for the full list of reasons</li>
  <li>At the end of a lease, the tenant may end the tenancy and leave without notice, but the seller cannot end the tenancy without a valid reason</li>
  <li>Three months’ notice is required for an eviction</li>
  <li>The three-month period does not start on the day the notice is given</li>
  <li>See “tenant eviction steps” below for more information</li>
  <li>When a tenant moves out, the property owner at that time is responsible for the tenant’s security deposit or pet deposit</li>
  <li>Ensure the contract provides that the deposit is credited to the buyer on the statement of adjustments on completion</li>
</ol><br/>
<p><strong>Compensation:</strong><br/>
When serving a Three Month Notice to End Tenancy, the landlord must compensate the tenant with an amount equal to one month’s rent, paid on or before the effective date of the notice period. Compensation is owed even if the tenant gives notice to leave earlier. The tenant may choose not to pay rent in the final month of the tenancy instead of receiving a payment from the landlord.
<br/><br/>
<a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/ending-a-tenancy/evictions/types-of-evictions" target="_blank" rel="noopener noreferrer">Click here</a> for more information on types of tenant evictions.
</p>     
</p>`,
    text: [
      {
        title: "Listing Side",
        text: `
        <ol>
  <li>Work with the tenants, not against them</li>
  <li>If a property management company is involved, obtain tenant information from them</li>
  <li>If you plan to use a lockbox, you must have the tenant sign an agreement consenting to it</li>
  <li>Tenants must agree to photos being taken and advertised</li>
  <li>It is recommended to show tenants the photos before posting them</li>
  <li><a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/during-a-tenancy/selling-a-tenanted-property" target="_blank" rel="noopener noreferrer">Click here </a> for more information</li>
</ol><br/>
<strong>Showing the Property:</strong><br/>
<ol>
  <li>The landlord or the landlord’s agent must be present</li>
  <li>The landlord cannot require the tenant to leave when the rental unit is being shown</li>
  <li>The landlord must provide written notice to the tenant, or have the tenant’s permission, to enter and show the unit to prospective buyers or to conduct an open house</li>
  <li>Ideally, the landlord and tenant should agree in writing on a schedule for viewing times</li>
  <li>If no schedule is agreed upon, the landlord must give the tenant 24 hours written notice for each showing of the unit</li>
</ol>
<br/>
<strong>Notice Must Have:</strong><br/>
<ol>
  <li>Reason for entering the rental unit</li>
  <li>Date and time of entry, which must be between 8 a.m. and 9 p.m., unless the tenant agrees to another time</li>
  <li>If proper notice is given, the property may be shown even if the tenant is not home</li>
  <li>Proper notice means the tenant is given written notice of the date, time, and purpose for entering the property</li>
  <li>By law, notice must be delivered in person or otherwise be considered legally given at least 24 hours before the landlord enters the unit</li>
</ol><br/>
<strong>When Notice Is Considered Received:</strong><br/>
<ol>
  <li>Considered same-day delivery: giving a copy directly to the tenant, or leaving a copy with an adult (19 years or older) who apparently lives with the tenant and noting the person’s name.</li>
<li>Considered delivered after 3 days: attaching a copy to the door or another noticeable place, leaving a copy in a mailbox or mail slot, or faxing a copy to the contact number provided.</li>
<li>Considered delivered after 5 days: sending a copy by registered or regular mail.</li>
<li>Does not count as delivered: sliding a copy under the tenant’s door, or using email or text messaging.</li>


`,
      },
      {
        title: "Buying Side",
        text: `
       <ol>
  <li>Putting “Vacant” under possession does not equal tenant eviction</li>
  <li>A contract is between the Seller and the Buyer, therefore the Seller cannot promise that the tenant will leave, as only the tenant can do that</li>
  <li>Once a property is sold, the buyer becomes the new landlord and the tenancy continues under the same terms</li>
  <li>The buyer and the tenant do not need to sign a new tenancy agreement, but may do so if both parties agree</li>
  <li>Regardless of whether the buyer is keeping the tenant, always include a tenancy clause in the contract in case the tenant does not leave at completion</li>
  <li>Always ask for a copy of the tenancy agreement, and if there is none, have the Seller list out the tenancy details</li>
</ol><br/>
<strong>Steps To End A Tenancy:</strong><br/>
<ol>
  <li>Buyer removes all subjects</li>
  <li>Buyer signs a promise to live in the tenant-occupied property using the Buyers Notice to Seller for Vacant Possession</li>
  <li>Buyer’s agent gives the above form to the Seller’s agent</li>
  <li>Seller gives a 3-month notice to end tenancy to the tenants</li>
  <li>Landlord must use the New Web Portal to generate the notice: <a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies" target="_blank" rel="noopener noreferrer">Please go to this link and know the rules to end tenancy</a></li>
  <li>Notice must be given before the day that the rent is due, not necessarily the 1st day of the month. Example: Subject removal June 1, Rent due June 1, Seller gives notice June 1, Tenants need to vacate by Aug 31 at 1 p.m.</li>
  <li>Reminder: the method of delivery will affect when the 2-month notice period begins</li>
  <li>A tenant must move out by 1 p.m. on the last day of the tenancy (usually the last day of the month). The landlord and tenant may agree on another time or date, as long as it is in writing and signed by both parties</li>
  <li>A tenant who receives this notice can give 10 days’ written notice and move out early. The landlord must still pay the tenant one month’s rent as compensation</li>
</ol>

      `,
      },
      {
        title: "Useful Clauses",
        text: `
       <strong class="bold">If Tenant Has Not Provided Notice to Vacate:</strong><br/>
       Seller hereby warrant that the tenant has given notice that they will be vacating _________________, by ___________________________<br/>
        <br/>
       <strong class="bold">Does the Seller need to give two full months’ notice if requested by the buyer after subjects are removed? (existing tenancies in Clause 5 can be left blank):</strong><br/>
       If the Seller receives a request from the Buyer to give Notice to End Tenancy in accordance with Section 49 of the Residential Tenancy Act, the Seller will promptly give a notice to end the tenancy in accordance with the provisions of the Residential Tenancy Act to any tenants of the property as specified.<br/>
       <br/>
       <strong class="bold">Does the Seller want to remain in possession, less than a week, 
       after Completion (Clause 5 Possession Date will be when Seller is to move out):</strong><br/>
       The Buyer will permit the Seller to remain in possession until the Possession Date as a “seller in possession.” The Buyer & Seller agree that the extension of possession past the Completion Date to the Possession Date does not create a tenancy agreement under the Residential Tenancy Act.<br/>
       <br/><strong class="bold">Does the Seller want to remain in possession for a longer term,
       but not as a tenant under the Residential Tenancy Act? (Clause 5 Possession Date 
       will be when Seller is to move out):</strong><br/>
       Subject to the Seller & the Buyer entering into an agreement on or before ___________________(date)_for the Seller to remain in possession until the Possession Date as a “seller in possession.” The Buyer & Seller agree that the extension of possession past the Completion Date to the Possession Date does not create a tenancy agreement under the Residential Tenancy Act.” This subject is for the benefit of the Buyer & Seller
       `,
      },
    ],
  },
];

export default transactionTopics;

/*template
{
    type: "transaction topic",
    id: "commission",
    title: "Commission Related Practices",
    description: `<p>
    Ensure you are using the correct form for Commission Agreements:
      <a
                    href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Commission Agreement Form
                  </a>
                  <br />
      <br/><br/>
     </p>`,
    text: [
      {
        title: "How to Ask for a Commission Increase as a Buyer Agent",
        text: `
        <strong>Judicial Foreclosure Overview</strong><br/>
        Foreclosures in BC are a. 
        <br/><strong class="bold">Action:</strong> Review the lender's.
        <br/><br/>`,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Constraints</strong><br/>
        Most lenders.
        <br/><strong class="bold">Action:</strong> Engage a.
        <br/><br/>
      `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Will the lender or court guarantee vacant possession? (Usually no — confirm in writing if vacant possession is ordered by the court.)</li>
        </ol>

        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
       
        <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer.
        <br/><br/>
        Always recommend legal review of the contract by the Buyer's lawyer or 
        notary before finalizing.
        <br/><br/>
        Review the <a href="/BC/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a> section for detailed examples of common conditions and clauses.
        
      `,
      },
    ],
  },
  */
